// AKSU Business School - Official Semester Course Curriculum & Dedicated Faculty Roster
// First Semester 2026/2027 Academic Session
// Domain: businessschool.aksu.edu.ng
// British English throughout

export const FACULTY_LECTURERS = [
  {
    id: "fac-uford",
    name: "Dr. Imoh Uford",
    formalSalutation: "Dr. Imoh Uford, PhD",
    rank: "Senior Lecturer in Data Science & Artificial Intelligence",
    qualifications: "B.Sc (Hons), M.Sc, PhD (Computer Science / Data Analytics), MNCS, MACM",
    title: "Senior Lecturer & Academic Chair of Business Analytics",
    department: "Department of Business Administration",
    email: "i.uford@faculty.aksu.edu.ng",
    demoUsername: "dr.uford@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Uford2026",
    assignedCourses: ["BUS 901", "MAF 801"],
    avatar: "https://images.unsplash.com/photo-1531384441138-2736e62e0919?q=80&w=300&auto=format&fit=crop",
    phone: "+234 803 245 9180",
    office: "Executive Faculty Suite 4B, Main Campus, Ikot Akpaden",
    consultationHours: "Tuesdays & Thursdays 14:00 - 16:30",
    bio: "Dr. Imoh Uford is a distinguished scholar in predictive analytics, machine learning, and business intelligence. He consults for national financial regulators and multinational energy corporations on enterprise data pipelines and AI governance.",
    researchInterests: [
      "Enterprise Machine Learning & Large Language Model Governance",
      "Predictive Analytics in Volatile Emerging Markets",
      "Bayesian Decision Networks in Corporate Strategy"
    ],
    workingPapers: [
      {
        id: "wp-uford-1",
        title: "Large Language Model Adoption in Sub-Saharan Corporate Governance: An Empirical Trust Framework",
        status: "Under Review at Journal of Business Analytics",
        date: "October 2026",
        grantSupport: "TETFUND National Research Fund (NRF/2026/AI)"
      },
      {
        id: "wp-uford-2",
        title: "Algorithmic Credit Scoring Models Under Unbanked Macroeconomic Volatility",
        status: "Working Draft / Data Collection",
        date: "September 2026",
        grantSupport: "AKSU Institutional Research Grant"
      }
    ]
  },
  {
    id: "fac-daniel",
    name: "Dr. Ekere Jacob Daniel",
    shortName: "Dr. Ekere Daniel",
    formalSalutation: "Dr. Ekere Jacob Daniel, PhD",
    rank: "Associate Professor of Econometrics & Quantitative Analysis",
    qualifications: "B.Sc (Econs), M.Sc, PhD (Econometrics), FSS, MNAA",
    title: "Course Lecturer, BUS/DAF 911 & Director of Quantitative Modelling Lab",
    department: "Department of Business Administration",
    email: "e.daniel@faculty.aksu.edu.ng",
    altEmail: "dr.daniel@businessschool.aksu.edu.ng",
    demoUsername: "dr.daniel@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Daniel2026",
    assignedCourses: ["BUS 911", "DAF 911"],
    avatar: "/dr-daniel-ekere.png",
    phone: "+234 802 334 1172",
    office: "Quantitative Economics Suite 2A, Main Campus, Ikot Akpaden",
    consultationHours: "Saturdays 15:30 - 17:30 & Mondays 10:00 - 13:00",
    bio: "Dr. Ekere Jacob Daniel is an Associate Professor of Econometrics & Quantitative Analysis at Akwa Ibom State University Business School. He specialises in probability and statistical inference, the classical linear regression model and its extensions, instrumental variables estimation (2SLS), dynamic panel data econometrics, time series forecasting, and hands-on empirical modeling using Stata, R, and Python on published firm-level and management datasets for executive doctoral inquiries.",
    researchInterests: [
      "Dynamic Panel Econometrics & Structural Equation Modelling",
      "Macro-Financial Volatility & Commodity Price Shock Transmission",
      "Instrumental Variables & Endogeneity in Corporate Governance",
      "Non-Linear Cointegration in African Capital Markets"
    ],
    workingPapers: [
      {
        id: "wp-daniel-1",
        title: "Asymmetric Cointegration Analysis of Exchange Rate Pass-Through on Capital Goods in Nigeria",
        status: "Accepted for Publication - African Development Review",
        date: "October 2026",
        grantSupport: "African Economic Research Consortium (AERC)"
      },
      {
        id: "wp-daniel-2",
        title: "BUS/DAF 911: Advanced Econometric Modeling with Stata, R & Python for Doctoral Business Research",
        status: "Official Course Monograph & Handbook - AKSU Business School Press",
        date: "Academic Session 2025/2026",
        grantSupport: "AKSU Business School Doctoral Curriculum Fund"
      }
    ]
  },
  {
    id: "fac-brownson",
    name: "Prof. Christabel Brownson",
    formalSalutation: "Prof. Christabel Brownson, PhD",
    rank: "Professor of Strategic Management & Business Theory",
    qualifications: "B.Sc, MBA, PhD (Business Administration), FNIM, FIMC, CMC",
    title: "Professor of Business Management & Former Dean of Management Sciences",
    department: "Department of Business Administration",
    email: "c.brownson@faculty.aksu.edu.ng",
    demoUsername: "prof.brownson@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Brownson2026",
    assignedCourses: ["BUS 921"],
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=300&auto=format&fit=crop",
    phone: "+234 803 555 8820",
    office: "Executive Dean's Emeritus Suite, Main Campus, Ikot Akpaden",
    consultationHours: "Fridays 11:00 - 15:00",
    bio: "Prof. Christabel Brownson is a pioneer authority on dynamic capabilities, organizational redesign, and institutional theory across developing economies. She serves on executive corporate advisory boards throughout West Africa.",
    researchInterests: [
      "Dynamic Capabilities & Strategic Adaptation in Emerging Economies",
      "Institutional Theory & Stakeholder Governance Paradigms",
      "Organisational Resilience and Agility in Family Conglomerates"
    ],
    workingPapers: [
      {
        id: "wp-brownson-1",
        title: "Dynamic Resource Reconfiguration as an Antidote to Macroeconomic Shocks in Sub-Saharan Africa",
        status: "Revise & Resubmit - Strategic Management Journal",
        date: "October 2026",
        grantSupport: "International Academy of African Business and Development (IAABD)"
      }
    ]
  },
  {
    id: "fac-akpan",
    name: "Prof. Anietie Akpan",
    formalSalutation: "Prof. Anietie Akpan, PhD",
    rank: "Professor of Corporate Strategy & Competitive Policy",
    qualifications: "B.Sc, M.Sc, PhD (Strategic Management), FNIMN, FCBA",
    title: "Professor of Strategic Management & Senior Consultant to State Economic Councils",
    department: "Department of Business Administration",
    email: "a.akpan@faculty.aksu.edu.ng",
    demoUsername: "prof.akpan@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Akpan2026",
    assignedCourses: ["BUS 931"],
    avatar: "https://images.unsplash.com/photo-1621972660173-bb6dab9bd598?q=80&w=300&auto=format&fit=crop",
    phone: "+234 803 777 4410",
    office: "Corporate Strategy Lab, Suite 5C, Main Campus, Ikot Akpaden",
    consultationHours: "Saturdays 13:00 - 16:00 (Post-Seminar)",
    bio: "Prof. Anietie Akpan is a renowned expert in industrial organization economics, competitive advantage formulation, blue ocean value innovation, and corporate restructuring in energy and maritime corridors.",
    researchInterests: [
      "Competitive Positioning in De-regulated Emerging Markets",
      "Blue Ocean Strategy Formulation in Blue Economy & Deepwater Ports",
      "Mergers, Acquisitions and Strategic Alliance Viability"
    ],
    workingPapers: [
      {
        id: "wp-akpan-1",
        title: "Competitive Moats and Value Innovation Along the Gulf of Guinea Maritime Industrial Belt",
        status: "Under Review - Journal of African Business",
        date: "September 2026",
        grantSupport: "Akwa Ibom State Economic Advisory Council Research Fellowship"
      }
    ]
  },
  {
    id: "fac-ukpong",
    name: "Dr. (Mrs) Eno Ukpong (Ass.Prof)",
    formalSalutation: "Dr. (Mrs) Eno Ukpong, PhD (Associate Professor)",
    rank: "Associate Professor of Business Communication & Research Methodology",
    qualifications: "B.A., M.Sc, PhD (Business Communication & Research Ethics), MNIM, FICA",
    title: "Associate Professor & Senate Chair of Postgraduate Research Integrity",
    department: "Department of Business Administration",
    email: "e.ukpong@faculty.aksu.edu.ng",
    demoUsername: "dr.ukpong@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Ukpong2026",
    assignedCourses: ["BUS 941", "DAF 941"],
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=300&auto=format&fit=crop",
    phone: "+234 806 889 2314",
    office: "Doctoral Academic Writing Clinic, Suite 3E, Main Campus",
    consultationHours: "Wednesdays & Thursdays 11:00 - 14:00",
    bio: "Dr. (Mrs) Eno Ukpong is an Associate Professor specializing in academic research design, high-impact publication ethics, peer review navigation, and executive rhetoric. She mentors doctoral fellows toward publishing in ABS 3* and 4* journals.",
    researchInterests: [
      "Publishing Ethics & Plagiarism Prevention in Postgraduate Education",
      "Executive Whitepaper Framing and High-Impact Policy Translation",
      "Bibliometric Analysis and Systematic Literature Review Protocols"
    ],
    workingPapers: [
      {
        id: "wp-ukpong-1",
        title: "Ethical Considerations in Executive Research: Grounding AI Co-Authorship Within NUC Benchmarks",
        status: "Invited Keynote Paper - Postgraduate Colloquium 2026",
        date: "October 2026",
        grantSupport: "AKSU Senate Committee on Academic Ethics"
      }
    ]
  },
  {
    id: "fac-mbobo",
    name: "Dr. Mbobo Mbobo",
    formalSalutation: "Dr. Mbobo Mbobo, PhD, FCA",
    rank: "Senior Lecturer in Financial Accounting & IFRS Reporting",
    qualifications: "B.Sc, M.Sc, PhD (Accounting), FCA, ACTI, FIIA",
    title: "Senior Lecturer & ICAN Academic Liaison Officer",
    department: "Department of Accounting",
    email: "m.mbobo@faculty.aksu.edu.ng",
    demoUsername: "dr.mbobo@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Mbobo2026",
    assignedCourses: ["ACC 801"],
    avatar: "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?q=80&w=300&auto=format&fit=crop",
    phone: "+234 803 661 2940",
    office: "Financial Reporting Suite 1D, Main Campus, Ikot Akpaden",
    consultationHours: "Tuesdays & Fridays 09:30 - 12:30",
    bio: "Dr. Mbobo Mbobo is a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN) and a seasoned authority on International Financial Reporting Standards (IFRS 9, 15, 16), fair value measurement, and consolidated reporting.",
    researchInterests: [
      "Fair Value Accounting Reliability Under Hyper-Inflationary Pressures",
      "IFRS 9 Expected Credit Loss Modelling for Commercial Banks",
      "Corporate Carbon Disclosures and Integrated ESG Reporting"
    ],
    workingPapers: [
      {
        id: "wp-mbobo-1",
        title: "Implementation Challenges of IFRS 17 Insurance Contracts Among Quoted Underwriters in Nigeria",
        status: "Under Review - Journal of Accounting & Public Policy",
        date: "September 2026",
        grantSupport: "ICAN Research Foundation Grant (ICAN/RF/2026)"
      }
    ]
  },
  {
    id: "fac-ubom",
    name: "Prof. Anthonia Ubom",
    formalSalutation: "Prof. Anthonia Ubom, PhD",
    rank: "Professor of Banking, Corporate Finance & Asset Pricing",
    qualifications: "B.Sc, M.Sc, PhD (Banking & Finance), FCIB, FCFM, MNIM",
    title: "Professor of Corporate Finance & Chair of Financial Markets Colloquium",
    department: "Department of Banking & Finance",
    email: "a.ubom@faculty.aksu.edu.ng",
    demoUsername: "prof.ubom@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Ubom2026",
    assignedCourses: ["FIN 811", "FIN 911"],
    avatar: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=300&auto=format&fit=crop",
    phone: "+234 802 884 5590",
    office: "Capital Markets Lab, Suite 2B, Main Campus, Ikot Akpaden",
    consultationHours: "Mondays & Thursdays 12:00 - 15:00",
    bio: "Prof. Anthonia Ubom is a Fellow of the Chartered Institute of Bankers of Nigeria (CIBN). Her seminal scholarship spans empirical asset pricing, cost of capital determination, valuation of distressed conglomerates, and sovereign debt restructuring.",
    researchInterests: [
      "Multi-Factor Asset Pricing Models (Fama-French 5-Factor) in Frontier Exchanges",
      "Corporate Valuation Under Extreme Foreign Exchange Risk",
      "Fintech Disruption and Capital Structure Optimisation"
    ],
    workingPapers: [
      {
        id: "wp-ubom-1",
        title: "Testing the Five-Factor Asset Pricing Model in the Nigerian Exchange Group (NGX): Empirical Evidence",
        status: "Accepted for Publication - Emerging Markets Review",
        date: "October 2026",
        grantSupport: "CIBN Academic Excellence Fund"
      },
      {
        id: "wp-ubom-2",
        title: "Valuation Multiples and Real Options Pricing in African Energy Infrastructure",
        status: "Working Draft / Data Simulation",
        date: "August 2026",
        grantSupport: "TETFUND National Research Fund"
      }
    ]
  },
  {
    id: "fac-okpo",
    name: "Dr. S. A. Okpo",
    formalSalutation: "Dr. S. A. Okpo, PhD",
    rank: "Senior Lecturer in Management Accounting & Strategic Cost Control",
    qualifications: "B.Sc, M.Sc, PhD (Management Accounting), CNA, ACTI, FCMA",
    title: "Senior Lecturer & Coordinator of Executive Management Accounting",
    department: "Department of Accounting",
    email: "s.okpo@faculty.aksu.edu.ng",
    demoUsername: "dr.okpo@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Okpo2026",
    assignedCourses: ["ACC 811"],
    avatar: "https://images.unsplash.com/photo-1626913619014-46bf28c9614d?q=80&w=300&auto=format&fit=crop",
    phone: "+234 803 992 4101",
    office: "Cost & Management Accounting Suite 3A, Main Campus",
    consultationHours: "Wednesdays 10:00 - 14:00",
    bio: "Dr. S. A. Okpo is an authority in Strategic Management Accounting (SMA), Activity-Based Costing (ABC), performance evaluation dashboards, and transfer pricing mechanisms across multinational supply chains.",
    researchInterests: [
      "Activity-Based Costing & Time-Driven ABC in Healthcare & Oil Services",
      "Strategic Performance Measurement & The Balanced Scorecard",
      "Transfer Pricing Audits and Tax Optimization in Developing Jurisdictions"
    ],
    workingPapers: [
      {
        id: "wp-okpo-1",
        title: "Strategic Management Accounting Techniques and Operational Performance of Manufacturing Firms",
        status: "Under Review - Management Accounting Research",
        date: "October 2026",
        grantSupport: "Association of National Accountants of Nigeria (ANAN)"
      }
    ]
  },
  {
    id: "fac-eshiet",
    name: "Dr. Udeme Eshiet",
    formalSalutation: "Dr. Udeme Eshiet, PhD",
    rank: "Senior Lecturer in Empirical Research Methodology & Financial Analytics",
    qualifications: "B.Sc, M.Sc, PhD (Financial Economics / Methodology), MNIM, MRSA",
    title: "Senior Lecturer & Director of Postgraduate Research Methodology",
    department: "Department of Banking & Finance",
    email: "u.eshiet@faculty.aksu.edu.ng",
    demoUsername: "dr.eshiet@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Eshiet2026",
    assignedCourses: ["MAF 811"],
    avatar: "https://images.unsplash.com/photo-1507152832244-10d45c7eda57?q=80&w=300&auto=format&fit=crop",
    phone: "+234 802 771 9043",
    office: "Postgraduate Research Suite 4C, Main Campus, Ikot Akpaden",
    consultationHours: "Tuesdays & Thursdays 13:00 - 16:00",
    bio: "Dr. Udeme Eshiet is an expert in empirical survey methodology, secondary econometric research design, and sampling validity for master's and doctoral finance dissertations.",
    researchInterests: [
      "Empirical Methodology in Corporate Finance & Financial Institutions",
      "Survey Instrument Design and Non-Response Bias in Executive Samples",
      "Mixed-Method Methodological Triangulation in Banking Inquiries"
    ],
    workingPapers: [
      {
        id: "wp-eshiet-1",
        title: "Overcoming Common Method Bias in African Financial Services Survey Data: A Procedural Protocol",
        status: "Accepted for Publication - Journal of African Financial Studies",
        date: "September 2026",
        grantSupport: "AKSU Academic Development Fund"
      }
    ]
  },
  {
    id: "fac-ibok",
    name: "Prof. Nkanikpo Ibok",
    formalSalutation: "Prof. Nkanikpo Ibok, PhD",
    rank: "Professor of Philosophy of Business Research & Behavioral Inquiry",
    qualifications: "B.Sc, M.Sc, PhD (Marketing & Business Foundations), FNIMN, FMS",
    title: "Professor of Business Research & Chairman of Senate Academic Standards",
    department: "Department of Business Administration",
    email: "n.ibok@faculty.aksu.edu.ng",
    demoUsername: "prof.ibok@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Ibok2026",
    assignedCourses: ["DAF 901"],
    avatar: "https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?q=80&w=300&auto=format&fit=crop",
    phone: "+234 803 119 6601",
    office: "Doctoral Epistemology Suite 6A, Senate Building, Main Campus",
    consultationHours: "Saturdays 12:00 - 15:30 (Executive Colloquium Hours)",
    bio: "Prof. Nkanikpo Ibok is a senior academic statesman who leads the doctoral epistemology colloquia at AKSU Business School. He is a master philosopher of social science inquiry, grounding doctoral scholars in ontology, axiology, and hermeneutics.",
    researchInterests: [
      "Epistemological Foundations of Business and Financial Inquiry",
      "Hermeneutics, Critical Realism, and Post-Positivism in Doctoral Research",
      "Ontological Consistency in Executive Dissertation Defences"
    ],
    workingPapers: [
      {
        id: "wp-ibok-1",
        title: "From Aristotle to Saunders: Tracing Ontological Stances in African Corporate Governance Research",
        status: "Keynote Presidential Address / Forthcoming Book Chapter",
        date: "October 2026",
        grantSupport: "National Universities Commission (NUC) Distinguished Lecture Series"
      }
    ]
  },
  {
    id: "fac-udoayang",
    name: "Prof. Joseph Udoayang",
    formalSalutation: "Prof. Joseph Udoayang, PhD, FCA",
    rank: "Professor of Financial Accounting Theory & Forensic Investigation",
    qualifications: "B.Sc, M.Sc, PhD (Accounting), FCA, FCTI, FCFE",
    title: "Professor of Accounting Theory & Senior Research Fellow in Financial Forensics",
    department: "Department of Accounting",
    email: "j.udoayang@faculty.aksu.edu.ng",
    demoUsername: "prof.udoayang@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@Udoayang2026",
    assignedCourses: ["ACC 911"],
    avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=300&auto=format&fit=crop",
    phone: "+234 803 448 9021",
    office: "Forensic Accounting Research Laboratory, Suite 1A, Main Campus",
    consultationHours: "Fridays & Saturdays 10:00 - 13:00",
    bio: "Prof. Joseph Udoayang is a renowned authority in positive accounting theory, agency theory, capital market efficiency anomalies, and forensic accounting investigation. He advises national anti-corruption agencies on forensic financial audits.",
    researchInterests: [
      "Positive Accounting Theory & Agency Cost Reduction Mechanisms",
      "Earnings Management Diagnostics via Discretionary Accruals Models",
      "Forensic Accounting Standards in Cross-Border Capital Flows"
    ],
    workingPapers: [
      {
        id: "wp-udoayang-1",
        title: "Beneish M-Score and Jones Model Comparative Efficacy in Detecting Financial Misstatements in West Africa",
        status: "Under Review - Journal of Accounting & Economics",
        date: "October 2026",
        grantSupport: "Chartered Institute of Taxation of Nigeria (CITN) Research Grant"
      }
    ]
  }
];

// =========================================================================================
// MASTER SEMESTER COURSES CURRICULUM
// Complete definitions for all 15 Semester courses across DBA, MAF, and DAF
// =========================================================================================

// =========================================================================================
// INAUGURAL COHORT: 6 CANDIDATES ENROLLED IN DBA, MAF, AND DAF
// =========================================================================================
export const INAUGURAL_CANDIDATES = [
  // 1 & 2: Doctor of Business Administration (DBA)
  {
    id: 'student-dba',
    matric: 'AKSU/BS/2026/DBA/012',
    name: 'Emem Udoh',
    email: 'emem.udoh@student.aksu.edu.ng',
    programmeId: 'dba',
    programmeName: 'Doctor of Business Administration (DBA)',
    degreeLevel: 'Doctorate',
    attendanceRate: 100,
    submissionStatus: 'Submitted (Awaiting Grade)',
    grade: 'Pending',
    avatar: 'https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?q=80&w=300&auto=format&fit=crop'
  },
  {
    id: 'student-dba-2',
    matric: 'AKSU/BS/2026/DBA/015',
    name: 'Obong Victor Okon',
    email: 'victor.okon@student.aksu.edu.ng',
    programmeId: 'dba',
    programmeName: 'Doctor of Business Administration (DBA)',
    degreeLevel: 'Doctorate',
    attendanceRate: 96,
    submissionStatus: 'Graded',
    grade: '91/100',
    avatar: 'https://images.unsplash.com/photo-1621972660173-bb6dab9bd598?q=80&w=300&auto=format&fit=crop'
  },

  // 3 & 4: Master of Accounting and Finance (MAF)
  {
    id: 'student-maf',
    matric: 'AKSU/BS/2026/MAF/018',
    name: 'Bassey Edet',
    email: 'bassey.edet@student.aksu.edu.ng',
    programmeId: 'maf',
    programmeName: 'Master of Accounting and Finance (MAF)',
    degreeLevel: "Master's",
    attendanceRate: 100,
    submissionStatus: 'Submitted',
    grade: '88/100',
    avatar: 'https://images.unsplash.com/photo-1531384441138-2736e62e0919?q=80&w=300&auto=format&fit=crop'
  },
  {
    id: 'student-maf-2',
    matric: 'AKSU/BS/2026/MAF/022',
    name: 'Blessing Eno Archibong',
    email: 'blessing.archibong@student.aksu.edu.ng',
    programmeId: 'maf',
    programmeName: 'Master of Accounting and Finance (MAF)',
    degreeLevel: "Master's",
    attendanceRate: 94,
    submissionStatus: 'Submitted (Needs Review)',
    grade: 'Pending',
    avatar: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?q=80&w=300&auto=format&fit=crop'
  },

  // 5 & 6: Doctor of Accounting and Finance (DAF)
  {
    id: 'student-daf',
    matric: 'AKSU/BS/2026/DAF/003',
    name: 'Dr. Clementina Okon',
    email: 'clementina.okon@student.aksu.edu.ng',
    programmeId: 'daf',
    programmeName: 'Doctor of Accounting and Finance (DAF)',
    degreeLevel: 'Doctorate',
    attendanceRate: 100,
    submissionStatus: 'Graded',
    grade: '94/100',
    avatar: 'https://images.unsplash.com/photo-1573496799652-408c2ac9fe98?q=80&w=300&auto=format&fit=crop'
  },
  {
    id: 'student-daf-2',
    matric: 'AKSU/BS/2026/DAF/007',
    name: 'Kufre Mfoniso James',
    email: 'kufre.james@student.aksu.edu.ng',
    programmeId: 'daf',
    programmeName: 'Doctor of Accounting and Finance (DAF)',
    degreeLevel: 'Doctorate',
    attendanceRate: 95,
    submissionStatus: 'Submitted (Awaiting Grade)',
    grade: 'Pending',
    avatar: 'https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?q=80&w=300&auto=format&fit=crop'
  }
];

export const DBA_CANDIDATES = INAUGURAL_CANDIDATES.filter(c => c.programmeId === 'dba');
export const MAF_CANDIDATES = INAUGURAL_CANDIDATES.filter(c => c.programmeId === 'maf');
export const DAF_CANDIDATES = INAUGURAL_CANDIDATES.filter(c => c.programmeId === 'daf');

export const SEMESTER_COURSES = [
  // ---------------------------------------------------------------------------------------
  // 1. DOCTOR OF BUSINESS ADMINISTRATION (DBA) COURSES
  // ---------------------------------------------------------------------------------------
  {
    code: "BUS 901",
    title: "Data Science and Artificial intelligence",
    shortTitle: "Data Science & AI",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Business Administration",
    schedule: "Saturdays 09:00 - 12:00",
    venue: "Amphitheatre A & Simultaneous Virtual Studio",
    lecturerId: "fac-uford",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-uford"),
    overview: "Advanced doctoral exploration of enterprise data engineering, machine learning architectures, generative artificial intelligence, and predictive modeling for C-suite business strategy. Focuses on transforming high-dimensional corporate data into actionable competitive advantage in emerging markets.",
    learningOutcomes: [
      "Architect enterprise AI roadmaps aligned with regulatory compliance and ethical standards.",
      "Deploy predictive models (regression, random forests, XGBoost) to forecast supply chain and market demands.",
      "Evaluate generative AI governance risks, algorithmic bias, and board-level data stewardship.",
      "Formulate doctoral research frameworks leveraging big data analytics for organizational transformation."
    ],
    modules: [
      {
        number: "Module 1",
        title: "Foundations of Big Data, Cloud Infrastructure & Business Intelligence",
        duration: "55 mins",
        videoTimestamp: 0,
        keyTakeaway: "Understanding data warehousing, ETL pipelines, and high-velocity analytics in corporate strategy.",
        status: "Active / Published"
      },
      {
        number: "Module 2",
        title: "Supervised and Unsupervised Machine Learning for Executive Decision-Making",
        duration: "65 mins",
        videoTimestamp: 20,
        keyTakeaway: "Formulating clustering, classification, and customer lifetime value algorithms without coding bottlenecks.",
        status: "Active / Published"
      },
      {
        number: "Module 3",
        title: "Generative AI, Large Language Models (LLMs) & Corporate Knowledge Bases",
        duration: "50 mins",
        videoTimestamp: 45,
        keyTakeaway: "Retrieval-Augmented Generation (RAG) frameworks for enterprise policy querying and automated intelligence.",
        status: "Upcoming"
      },
      {
        number: "Module 4",
        title: "AI Ethics, Algorithmic Bias, NDPR/GDPR Compliance & Board Oversight",
        duration: "45 mins",
        videoTimestamp: 70,
        keyTakeaway: "Institutional data protection frameworks and liability mitigation for senior directors.",
        status: "Upcoming"
      },
      {
        number: "Module 5",
        title: "Doctoral Research Design: Incorporating Data Science into Business Inquiries",
        duration: "60 mins",
        videoTimestamp: 95,
        keyTakeaway: "Constructing empirical quantitative frameworks bridging computational models with management theory.",
        status: "Upcoming"
      }
    ],
    materials: [
      {
        id: "mat-bus901-1",
        title: "BUS 901 Course Syllabus & Executive AI Architecture Reader",
        type: "Syllabus",
        size: "3.8 MB",
        date: "14 Oct 2026",
        file: "BUS901_Syllabus_DataScience_AI_2026.pdf",
        status: "Published"
      },
      {
        id: "mat-bus901-2",
        title: "Executive Slide Deck: Machine Learning Paradigms for C-Suite Leaders",
        type: "Slides",
        size: "8.2 MB",
        date: "16 Oct 2026",
        file: "BUS901_Mod1_Enterprise_ML_Slides.pdf",
        status: "Published"
      },
      {
        id: "mat-bus901-3",
        title: "Harvard / Industry Case: Predictive Analytics in Downstream Energy Logistics",
        type: "Case Study",
        size: "2.4 MB",
        date: "17 Oct 2026",
        file: "Case_Energy_Logistics_Predictive_Model.pdf",
        status: "Published"
      },
      {
        id: "mat-bus901-4",
        title: "Live Lecture Video Recording: AI Governance & Strategic Algorithm Deployment",
        type: "Video",
        size: "620 MB",
        date: "18 Oct 2026",
        file: "BUS901_Session1_AI_Governance_HD.mp4",
        status: "Published"
      },
      {
        id: "mat-bus901-5",
        title: "Empirical Dataset: Nigerian Industrial Supply Chain Disruptions (2020-2026)",
        type: "Dataset",
        size: "14.5 MB",
        date: "19 Oct 2026",
        file: "Industrial_SupplyChain_Wave2026.xlsx",
        status: "Published"
      }
    ],
    assignments: [
      {
        id: "asg-bus901-1",
        title: "Continuous Assessment 1: Enterprise AI Strategy & Governance Blueprint",
        brief: "Select a real-world enterprise in Nigeria or West Africa. Formulate a 10-page C-suite proposal detailing the deployment of a predictive machine learning solution to address an operational bottleneck, incorporating data governance, compliance with NDPR, and risk mitigation.",
        dueDate: "31st October 2026",
        weight: "30% Continuous Assessment",
        points: 30,
        submissionsCount: 6,
        status: "Active / Grading in Progress"
      },
      {
        id: "asg-bus901-2",
        title: "Term Capstone Project: Applied Empirical Data Science Model",
        brief: "Formulate a doctoral-level empirical quantitative model using the provided corporate dataset. Estimate prediction accuracy and draft the methodology chapter for an executive dissertation.",
        dueDate: "28th November 2026",
        weight: "40% Examination Capstone",
        points: 40,
        submissionsCount: 0,
        status: "Upcoming"
      }
    ],
    enrolledStudents: DBA_CANDIDATES,
    announcements: [
      { id: "anc-1", date: "20 Oct 2026", title: "Live Laboratory Session: Python & R for Executive Analytics", body: "Please ensure your laptops are configured with Jupyter Lab and the course dataset downloaded prior to Saturday's 09:00 seminar." },
      { id: "anc-2", date: "15 Oct 2026", title: "Submission Portal for CA1 Open", body: "The portal is open for uploading Continuous Assessment 1 blueprints. PDF submissions are required." }
    ]
  },
  {
    code: "BUS 911",
    crossListing: "BUS/DAF 911",
    title: "Advanced Quantitative Analysis and Econometrics",
    shortTitle: "Adv. Quant & Econometrics",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2025/2026",
    academicSession: "2025/2026",
    department: "Department of Business Administration",
    schedule: "Saturdays 12:30 - 15:30",
    venue: "Doctoral Econometric Lab & Virtual Studio, Obio Akpa Campus / Uyo Liaison Office",
    lecturerId: "fac-daniel",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-daniel"),
    overview: "This course provides DBA candidates with advanced training in quantitative methods and econometric analysis for business research. It covers probability, sampling, and statistical inference; the classical linear regression model and its extensions; violations of classical assumptions including heteroskedasticity, autocorrelation, and endogeneity; instrumental variables estimation; diagnostic testing; and hands-on estimation using Stata, R, and Python with published management and firm-level datasets. The emphasis is on both theoretical understanding and practical application to doctoral-level research problems in business and management.",
    learningOutcomes: [
      "Master foundations of statistical inference, probability distributions, and hypothesis testing power.",
      "Formulate, estimate, and interpret the Classical Linear Regression Model (OLS) and its mathematical properties.",
      "Diagnose and remediate violations of classical assumptions: heteroskedasticity, autocorrelation, and endogeneity.",
      "Execute Instrumental Variables (2SLS) and dynamic panel data models to resolve omitted variable bias.",
      "Implement hands-on econometric workflows in Stata, R, and Python with published firm-level and management datasets.",
      "Critically evaluate and defend doctoral-level quantitative methodology for business research dissertations."
    ],
    modules: [
      {
        number: "Week 1",
        title: "Probability, Sampling, and Statistical Inference",
        majorTopic: "Foundations of statistical reasoning for business research",
        minorTopics: [
          "i. Probability distributions and random variables",
          "ii. Sampling methods and sampling distributions",
          "iii. Point estimation and confidence intervals",
          "iv. Hypothesis testing: Type I and Type II errors, power"
        ],
        readings: [
          "Stock & Watson (2021): chapters on probability and statistical inference",
          "Wooldridge (2025): chapters on the nature of econometrics and data",
          "Greene (2018): review of probability and distribution theory"
        ],
        duration: "180 mins",
        videoTimestamp: 0,
        keyTakeaway: "Foundations of statistical inference, probability distributions, confidence intervals, and hypothesis test power.",
        status: "Active / Published"
      },
      {
        number: "Week 2",
        title: "The Classical Linear Regression Model",
        majorTopic: "Simple and multiple linear regression; OLS estimation",
        minorTopics: [
          "i. The linear regression model and its assumptions",
          "ii. Ordinary Least Squares (OLS) estimation",
          "iii. Properties of OLS estimators: unbiasedness, efficiency, consistency",
          "iv. Goodness of fit and coefficient of determination"
        ],
        readings: [
          "Stock & Watson (2021): chapters on linear regression with one and multiple regressors",
          "Wooldridge (2025): chapters on simple and multiple regression analysis",
          "Greene (2018): the linear regression model and least squares estimation"
        ],
        duration: "180 mins",
        videoTimestamp: 20,
        keyTakeaway: "Gauss-Markov theorem, OLS unbiasedness, efficiency, consistency, and R-squared interpretation.",
        status: "Active / Published"
      },
      {
        number: "Week 3",
        title: "Inference in the Linear Regression Model",
        majorTopic: "Hypothesis testing and confidence intervals in regression",
        minorTopics: [
          "i. Sampling distributions of OLS estimators",
          "ii. t-tests and F-tests for linear restrictions",
          "iii. Confidence intervals and prediction intervals",
          "iv. Model specification and functional form"
        ],
        readings: [
          "Stock & Watson (2021): chapters on regression inference and hypothesis testing",
          "Wooldridge (2025): chapters on inference in multiple regression",
          "Greene (2018): hypothesis testing and model selection"
        ],
        duration: "180 mins",
        videoTimestamp: 40,
        keyTakeaway: "Joint hypothesis testing via F-tests, confidence bands, functional form transformations, and polynomial regressors.",
        status: "Active / Published"
      },
      {
        number: "Week 4",
        title: "Heteroskedasticity and Autocorrelation",
        majorTopic: "Violations of classical assumptions and robust inference",
        minorTopics: [
          "i. Detection of heteroskedasticity (Breusch-Pagan, White tests)",
          "ii. Consequences for OLS and remedial measures",
          "iii. Autocorrelation in time series: detection and correction",
          "iv. Heteroskedasticity-robust and autocorrelation-robust standard errors"
        ],
        readings: [
          "Wooldridge (2025): chapters on heteroskedasticity and serial correlation",
          "Greene (2018): the generalized regression model and heteroskedasticity",
          "Stock & Watson (2021): chapters on regression with time series data and robust standard errors"
        ],
        duration: "180 mins",
        videoTimestamp: 60,
        keyTakeaway: "White-Huber robust SEs, Breusch-Pagan test, Durbin-Watson, Newey-West HAC standard errors.",
        status: "Active / Published"
      },
      {
        number: "Week 5",
        title: "Endogeneity and Instrumental Variables",
        majorTopic: "Endogeneity problems and IV estimation",
        minorTopics: [
          "i. Sources of endogeneity: omitted variables, measurement error, simultaneity",
          "ii. Instrumental variables: validity and relevance conditions",
          "iii. Two-Stage Least Squares (2SLS) estimation",
          "iv. Testing for endogeneity and overidentification"
        ],
        readings: [
          "Wooldridge (2025): chapters on instrumental variables estimation",
          "Greene (2018): instrumental variables and simultaneous equations",
          "Angrist & Pischke (2009): chapters on instrumental variables and natural experiments"
        ],
        duration: "180 mins",
        videoTimestamp: 80,
        keyTakeaway: "Identification strategy, 2SLS estimation, Hausman endogeneity test, Sargan-Hansen J overidentification test.",
        status: "Upcoming"
      },
      {
        number: "Week 6",
        title: "Panel Data Models",
        majorTopic: "Fixed effects, random effects, and panel data estimation",
        minorTopics: [
          "i. Benefits of panel data for controlling unobserved heterogeneity",
          "ii. Pooled OLS, fixed effects, and first-differencing estimators",
          "iii. Random effects estimation and the Hausman test",
          "iv. Clustered standard errors in panel settings"
        ],
        readings: [
          "Wooldridge (2025): chapters on panel data models",
          "Greene (2018): models for panel data",
          "Angrist & Pischke (2009): chapters on panel data and difference-in-differences"
        ],
        duration: "180 mins",
        videoTimestamp: 100,
        keyTakeaway: "Within-group vs between-group transformation, Hausman test, and firm-clustered standard errors.",
        status: "Upcoming"
      },
      {
        number: "Week 7",
        title: "Binary Choice and Limited Dependent Variable Models",
        majorTopic: "Qualitative response models for limited dependent variables",
        minorTopics: [
          "i. Linear Probability Model: estimation and drawbacks",
          "ii. Logit and Probit models: specification and interpretation",
          "iii. Maximum Likelihood Estimation for binary outcomes",
          "iv. Marginal effects and goodness-of-fit measures"
        ],
        readings: [
          "Wooldridge (2025): chapters on discrete response models",
          "Greene (2018): discrete choice models",
          "Stock & Watson (2021): chapters on binary dependent variables"
        ],
        duration: "180 mins",
        videoTimestamp: 120,
        keyTakeaway: "Odds ratios, Probit vs Logit, Maximum Likelihood estimation, and average marginal effects (AME).",
        status: "Upcoming"
      },
      {
        number: "Week 8",
        title: "Diagnostic Testing and Model Specification",
        majorTopic: "Specification tests and model validation",
        minorTopics: [
          "i. Tests for omitted variables and functional form misspecification",
          "ii. Ramsey RESET test and related diagnostics",
          "iii. Tests for structural breaks",
          "iv. Outlier detection and influence diagnostics"
        ],
        readings: [
          "Greene (2018): hypothesis testing and model selection",
          "Wooldridge (2019): chapters on specification testing",
          "Stock & Watson (2015): chapters on assessing studies and regression diagnostics"
        ],
        duration: "180 mins",
        videoTimestamp: 140,
        keyTakeaway: "Ramsey RESET test, Chow structural break test, Cook's distance, and leverage influence analysis.",
        status: "Upcoming"
      },
      {
        number: "Week 9",
        title: "Time Series: Stationarity, ARIMA, and Forecasting",
        majorTopic: "Time series econometrics for business forecasting",
        minorTopics: [
          "i. Stationarity and unit root tests (ADF, PP)",
          "ii. ARIMA models: identification, estimation, and diagnostic checking",
          "iii. Forecasting and forecast evaluation",
          "iv. Vector Autoregressions (VAR) for multivariate time series"
        ],
        readings: [
          "Stock & Watson (2021): chapters on time series regression and forecasting",
          "Greene (2018): time series models and nonstationary data",
          "Wooldridge (2025): chapters on time series regression"
        ],
        duration: "180 mins",
        videoTimestamp: 160,
        keyTakeaway: "Augmented Dickey-Fuller (ADF) & Phillips-Perron tests, Box-Jenkins ARIMA methodology, and VAR impulse response functions.",
        status: "Upcoming"
      },
      {
        number: "Week 10",
        title: "Hands-On Estimation in Stata",
        majorTopic: "Practical implementation of econometric methods in Stata",
        minorTopics: [
          "i. Data management and exploratory analysis in Stata",
          "ii. Regression commands and robust standard errors",
          "iii. Panel data estimation and post-estimation commands",
          "iv. Reproducible research workflows"
        ],
        readings: [
          "Adkins & Hill (2011): Using Stata for Principles of Econometrics (4th ed.)",
          "Wooldridge (2025): empirical exercises and computer exercises",
          "Selected Stata documentation and tutorials (to be sourced)"
        ],
        duration: "180 mins",
        videoTimestamp: 180,
        keyTakeaway: "Mastering Stata commands: regress, ivregress 2sls, xtreg, fe, re, estat hettest, and publication-ready outreg2 tables.",
        status: "Upcoming"
      },
      {
        number: "Week 11",
        title: "Hands-On Estimation in R and Python",
        majorTopic: "Practical implementation of econometric methods in R and Python",
        minorTopics: [
          "i. Data manipulation and visualization in R/Python",
          "ii. Regression, panel data, and binary choice estimation",
          "iii. Packages and libraries for econometrics",
          "iv. Comparison of Stata, R, and Python workflows"
        ],
        readings: [
          "Angrist & Pischke (2009): empirical examples and replication logic",
          "Selected R and Python econometrics tutorials (provided in class)",
          "Wooldridge (2025): computer exercises adaptable to R/Python"
        ],
        duration: "180 mins",
        videoTimestamp: 200,
        keyTakeaway: "Python statsmodels/linearmodels and R plm/fixest pipelines, tidyverse data wrangling, and ggplot2 diagnostics.",
        status: "Upcoming"
      },
      {
        number: "Week 12",
        title: "Applications to Firm-Level and Management Data",
        majorTopic: "Empirical applications using published business datasets",
        minorTopics: [
          "i. Working with firm-level datasets (Compustat-style, survey data)",
          "ii. Endogeneity and identification in management research",
          "iii. Panel data applications in strategy and finance",
          "iv. Replication and robustness in empirical business research"
        ],
        readings: [
          "Angrist & Pischke (2009): applications and empirical strategies",
          "Selected published papers using firm-level data (to be sourced)",
          "Wooldridge (2025): empirical examples and case studies"
        ],
        duration: "180 mins",
        videoTimestamp: 220,
        keyTakeaway: "Managing micro datasets, addressing survival bias, winsorization, cluster correction, and robustness test matrices.",
        status: "Upcoming"
      },
      {
        number: "Week 13",
        title: "Course Review and Research Project Presentations",
        majorTopic: "Synthesis and assessment",
        minorTopics: [
          "i. Integration of econometric methods for DBA research",
          "ii. Research project presentations",
          "iii. Course review and examination preparation"
        ],
        readings: [
          "Review all assigned readings across Weeks 1 to 12"
        ],
        duration: "180 mins",
        videoTimestamp: 240,
        keyTakeaway: "Defending econometric methodology before doctoral review panel, addressing identification challenges, and Viva Voce preparation.",
        status: "Upcoming"
      }
    ],
    generalReferences: [
      {
        id: 1,
        author: "Stock, J. H., & Watson, M. W.",
        year: "2021",
        title: "Introduction to Econometrics",
        edition: "4th ed., Global Edition",
        publisher: "Pearson",
        isbn: "9781292264455",
        citation: "Stock, J. H., & Watson, M. W. (2021). Introduction to Econometrics (4th ed.). Pearson. ISBN: 9781292264455.",
        url: "https://www.pearson.com/en-gb/subject-catalog/p/introduction-to-econometrics-global-edition/P200000005728/9781292264455",
        altUrl: "https://www.worldcat.org/isbn/9781292264455",
        companionUrl: "https://www.princeton.edu/~mwatson/Stock-Watson-4_Global/",
        scope: "Foundational theory of probability, statistical inference, single & multiple regression, instrumental variables, and time series."
      },
      {
        id: 2,
        author: "Wooldridge, J. M.",
        year: "2025",
        title: "Introductory Econometrics: A Modern Approach",
        edition: "8th ed.",
        publisher: "Cengage Learning",
        isbn: "9798214050317",
        citation: "Wooldridge, J. M. (2025). Introductory Econometrics: A Modern Approach (8th ed.). Cengage. ISBN: 9798214050317.",
        url: "https://www.cengage.uk/9798214050317/",
        altUrl: "https://www.worldcat.org/isbn/9798214050317",
        scope: "Modern cross-sectional, time series, and panel data econometrics with extensive applied empirical computer exercises."
      },
      {
        id: 3,
        author: "Greene, W. H.",
        year: "2018",
        title: "Econometric Analysis",
        edition: "8th ed.",
        publisher: "Pearson",
        isbn: "9780134461366",
        citation: "Greene, W. H. (2018). Econometric Analysis (8th ed.). Pearson. ISBN: 9780134461366.",
        url: "https://www.pearson.com/en-us/subject-catalog/p/econometric-analysis/P200000005726/9780134461366",
        altUrl: "http://people.stern.nyu.edu/wgreene/Text/econometricanalysis.htm",
        scope: "Comprehensive doctoral-level treatise on linear and nonlinear econometric theory, generalized regression, GMM, and maximum likelihood."
      },
      {
        id: 4,
        author: "Angrist, J. D., & Pischke, J.-S.",
        year: "2009",
        title: "Mostly Harmless Econometrics: An Empiricist's Companion",
        edition: "1st ed.",
        publisher: "Princeton University Press",
        isbn: "9780691120355",
        citation: "Angrist, J. D., & Pischke, J.-S. (2009). Mostly Harmless Econometrics. Princeton University Press. ISBN: 9780691120355.",
        url: "https://press.princeton.edu/books/paperback/9780691120355/mostly-harmless-econometrics",
        altUrl: "https://www.mostlyharmlesseconometrics.com/",
        scope: "Applied identification strategies, natural experiments, instrumental variables, differences-in-differences, and regression discontinuity."
      },
      {
        id: 5,
        author: "Adkins, L. C., & Hill, R. C.",
        year: "2011",
        title: "Using Stata for Principles of Econometrics",
        edition: "4th ed.",
        publisher: "John Wiley & Sons",
        isbn: "9781118032084",
        citation: "Adkins, L. C., & Hill, R. C. (2011). Using Stata for Principles of Econometrics (4th ed.). Wiley. ISBN: 9781118032084.",
        url: "https://www.wiley.com/en-us/Using+Stata+for+Principles+of+Econometrics%2C+4th+Edition-p-9781118032084",
        altUrl: "http://www.principlesofeconometrics.com/stata.htm",
        scope: "Hands-on implementation of econometric techniques, commands, and do-files in Stata software."
      }
    ],
    softwareTools: [
      { name: "Stata 18", category: "Econometric Package", url: "https://www.stata.com/", desc: "Primary econometric estimation suite for OLS, 2SLS, panel data, and GMM." },
      { name: "R Project & CRAN", category: "Open Source Computing", url: "https://www.r-project.org/", desc: "Reproducible research, plm, fixest, and publication graphics." },
      { name: "Python Statsmodels", category: "Data Science & Econometrics", url: "https://www.statsmodels.org/", desc: "Statistical modeling, hypothesis testing, and regression diagnostics in Python." },
      { name: "Python Linearmodels", category: "Panel Econometrics", url: "https://bashtage.github.io/linearmodels/", desc: "Panel and instrumental variable regression models." }
    ],
    materials: [
      { id: "mat-bus911-outline", title: "BUS/DAF 911 Official Course Outline & Syllabus Dossier (2025/2026)", type: "Official Syllabus", size: "1.8 MB", date: "29 Oct 2026", file: "BUS_DAF_911_Official_Course_Outline_2025_2026.pdf", status: "Ratified & Live" },
      { id: "mat-bus911-ebook", title: "BUS/DAF 911 Executive Course Handbook & Study Reader (Interactive eBook)", type: "eBook Handbook", size: "6.2 MB", date: "30 Oct 2026", file: "BUS_DAF_911_Course_Handbook_eBook.html", status: "Published" },
      { id: "mat-bus911-stata", title: "Hands-On Econometrics in Stata 18 Guide & Do-Files Packet", type: "Software Lab", size: "8.4 MB", date: "28 Oct 2026", file: "Stata_18_Econometric_Estimation_Do_Files.zip", status: "Published" },
      { id: "mat-bus911-python", title: "Python & R Econometric Scripts for Dynamic Panel & IV Estimation", type: "Code Repository", size: "4.7 MB", date: "25 Oct 2026", file: "Python_R_Econometric_Notebooks.zip", status: "Published" },
      { id: "mat-bus911-data", title: "Empirical Firm-Level Dataset: Compustat & NGX Quoted Firms (2015-2025)", type: "Dataset", size: "26.3 MB", date: "20 Oct 2026", file: "Compustat_NGX_Firm_Level_Dataset.dta", status: "Published" },
      { id: "mat-bus911-refs", title: "Verified General Reference Bibliography & ISBN Reading List", type: "Bibliography", size: "1.2 MB", date: "29 Oct 2026", file: "Verified_References_Bibliography_ISBNs.pdf", status: "Published" }
    ],
    assignments: [
      { id: "asg-bus911-1", title: "CA1: Empirical Econometric Diagnostic Paper (Stata/R/Python)", brief: "Estimate a multivariate firm-level performance model using OLS and test for violations of classical assumptions (Heteroskedasticity, Autocorrelation, Multicollinearity). Present results in APA 7th edition regression tables.", dueDate: "15th November 2026", weight: "20% Continuous Assessment", points: 20, submissionsCount: 6, status: "Active" },
      { id: "asg-bus911-2", title: "CA2: Instrumental Variables (2SLS) & Dynamic Panel Model on Firm-Level Data", brief: "Formulate an identification strategy for an endogenous strategic variable (e.g., CEO duality, R&D intensity). Estimate via 2SLS and Fixed Effects panel data regressions. Report Hausman test and Hansen J overidentification tests.", dueDate: "29th November 2026", weight: "20% Continuous Assessment", points: 20, submissionsCount: 6, status: "Active" },
      { id: "asg-bus911-final", title: "Capstone: Doctoral Research Project Presentation & Viva Voce", brief: "Deliver a 15-minute empirical presentation integrating econometric methodology into your doctoral dissertation proposal, followed by faculty viva voce defense.", dueDate: "12th December 2026", weight: "50% Final Examination & Defense", points: 50, submissionsCount: 6, status: "Scheduled" }
    ],
    enrolledStudents: DBA_CANDIDATES,
    announcements: [
      { id: "anc-dan-1", date: "29 Oct 2026", title: "Official 2025/2026 Course Outline & Syllabus Published", body: "Dr. Ekere Jacob Daniel has published the official 13-week course syllabus for BUS/DAF 911. Please review the 5 verified reference texts and download the Stata/Python lab packets." },
      { id: "anc-dan-2", date: "25 Oct 2026", title: "Software Lab Access: Stata 18 & Python Environments", body: "Docker containers and Stata 18 licenses are now provisioned on the Quantitative Lab server. Check materials tab for installation guides." }
    ]
  },
  {
    code: "BUS 921",
    title: "Adv. Business Mgmt Theory",
    shortTitle: "Adv. Business Mgmt Theory",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Business Administration",
    schedule: "Fridays 16:00 - 19:00",
    venue: "Executive Boardroom Suite & Virtual Studio",
    lecturerId: "fac-brownson",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-brownson"),
    overview: "Critical examination of classical, contemporary, and emerging theories of business enterprise. Covers dynamic capabilities, resource-based view (RBV), institutional theory, organizational ecology, agency paradigms, and contingency models tailored to developing market contexts.",
    learningOutcomes: [
      "Critically deconstruct ontological assumptions underpinning management paradigms.",
      "Synthesize competing theories (RBV vs Institutional Theory) to explain corporate survival.",
      "Formulate novel theoretical conceptual frameworks for doctoral dissertations.",
      "Evaluate leadership stewardship, stakeholder governance, and sustainable business models."
    ],
    modules: [
      { number: "Module 1", title: "The Evolution of Management Thought: From Taylorism to Dynamic Capabilities", duration: "50 mins", videoTimestamp: 0, keyTakeaway: "Tracing knowledge claims from bureaucratic paradigms to open innovation ecosystems.", status: "Active / Published" },
      { number: "Module 2", title: "The Resource-Based View (RBV), VRIO Framework & Core Competencies", duration: "60 mins", videoTimestamp: 20, keyTakeaway: "Evaluating inimitable, non-substitutable resource bundles in competitive markets.", status: "Active / Published" },
      { number: "Module 3", title: "Institutional Theory, Isomorphism & Regulatory Pressures in Africa", duration: "55 mins", videoTimestamp: 45, keyTakeaway: "Coercive, mimetic, and normative isomorphism shaping corporate behavior.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-bus921-1", title: "BUS 921 Advanced Management Theory Compendium", type: "Syllabus", size: "5.1 MB", date: "11 Oct 2026", file: "BUS921_Management_Theory_Reader.pdf", status: "Published" },
      { id: "mat-bus921-2", title: "Seminar Presentation: Dynamic Capabilities Under High Macro Volatility", type: "Slides", size: "4.7 MB", date: "14 Oct 2026", file: "BUS921_Mod1_Dynamic_Capabilities.pdf", status: "Published" }
    ],
    assignments: [
      { id: "asg-bus921-1", title: "Theoretical Synthesis Matrix", brief: "Select two competing management theories and demonstrate how their integration resolves a persistent operational dilemma in Nigerian corporate conglomerates.", dueDate: "10th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 6, status: "Active" }
    ],
    enrolledStudents: DBA_CANDIDATES,
    announcements: [
      { id: "anc-cb-1", date: "16 Oct 2026", title: "Colloquium Presentation Topic Allocations", body: "The schedule for Friday syndicate presentations has been posted to your module dashboard." }
    ]
  },
  {
    code: "BUS 931",
    title: "Competitive Strategy",
    shortTitle: "Competitive Strategy",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Business Administration",
    schedule: "Saturdays 15:30 - 18:30",
    venue: "Amphitheatre B & Virtual Studio",
    lecturerId: "fac-akpan",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-akpan"),
    overview: "Formulation and execution of high-stakes corporate and business unit strategies. Deep dive into industry structural analysis (Porter's Five Forces), Blue Ocean value innovation, corporate diversification, strategic alliances, and game-theoretic competitive maneuvering.",
    learningOutcomes: [
      "Conduct industry structure diagnostics and pinpoint sustainable competitive moats.",
      "Execute blue ocean strategy canvases to unlock uncontested market spaces in West Africa.",
      "Evaluate cross-border market entry modes, mergers, and strategic joint ventures.",
      "Structure organizational change management architectures for turnaround strategy."
    ],
    modules: [
      { number: "Module 1", title: "Industry Analysis, Structural Five Forces & Competitive Advantage", duration: "55 mins", videoTimestamp: 0, keyTakeaway: "Diagnosing supplier power, threat of substitutes, and barriers to entry in emerging sectors.", status: "Active / Published" },
      { number: "Module 2", title: "Blue Ocean Strategy: Value Innovation Canvas & Strategy Curves", duration: "65 mins", videoTimestamp: 20, keyTakeaway: "Eliminating, reducing, raising, and creating factors to break the cost-value trade-off.", status: "Active / Published" },
      { number: "Module 3", title: "Corporate Diversification, Horizontal Integration & Value Destruction Risks", duration: "50 mins", videoTimestamp: 45, keyTakeaway: "Synergy verification and conglomerate discount pitfalls.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-bus931-1", title: "BUS 931 Competitive Strategy Master Packet", type: "Syllabus", size: "4.2 MB", date: "10 Oct 2026", file: "BUS931_Competitive_Strategy.pdf", status: "Published" },
      { id: "mat-bus931-2", title: "Industry Case: Port Infrastructure Strategic Positioning in Akwa Ibom", type: "Case Study", size: "3.1 MB", date: "16 Oct 2026", file: "Case_Ibom_Deep_Sea_Port_Strategy.pdf", status: "Published" }
    ],
    assignments: [
      { id: "asg-bus931-1", title: "Strategic Blue Ocean Canvas Formulation", brief: "Develop a Blue Ocean strategy canvas for an established Nigerian bank facing fintech disruption, outlining the 4-Actions framework.", dueDate: "14th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 6, status: "Active" }
    ],
    enrolledStudents: DBA_CANDIDATES,
    announcements: [
      { id: "anc-akp-1", date: "17 Oct 2026", title: "Harvard Case Packet Access Granted", body: "Digital access tokens for the maritime strategy case have been provisioned." }
    ]
  },
  {
    code: "BUS 941",
    title: "Business writing, publication &  research",
    shortTitle: "Business Writing & Publication",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Business Administration",
    schedule: "Thursdays 15:00 - 18:00",
    venue: "Doctoral Writing Studio & Virtual Studio",
    lecturerId: "fac-ukpong",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-ukpong"),
    overview: "Mastery of scholarly business communication, executive whitepaper architecture, and high-impact publishing in peer-reviewed academic journals (ABS 3*/4*, ABDC, Scopus). Covers academic integrity, response to reviewer comments, and research grant proposal structuring.",
    learningOutcomes: [
      "Structure doctoral dissertation chapters in rigorous compliance with Senate standards.",
      "Draft publishable empirical research manuscripts for top-tier indexed business journals.",
      "Navigate peer review feedback and author rebuttal letters with scholarly diplomatic precision.",
      "Adhere strictly to academic integrity, ethical clearance protocols, and anti-plagiarism benchmarks."
    ],
    modules: [
      { number: "Module 1", title: "Deconstructing the Anatomy of a Tier-1 Business Journal Article", duration: "50 mins", videoTimestamp: 0, keyTakeaway: "Crafting captivating introductions, problem statements, and theoretical contributions.", status: "Active / Published" },
      { number: "Module 2", title: "Academic Integrity, Plagiarism Diagnostics & Ethical Governance", duration: "45 mins", videoTimestamp: 20, keyTakeaway: "Turnitin benchmarks, citation protocols, and avoiding self-plagiarism.", status: "Active / Published" },
      { number: "Module 3", title: "Navigating Peer Review & Drafting Defensible Reviewer Rebuttals", duration: "55 mins", videoTimestamp: 45, keyTakeaway: "Handling revise-and-resubmit decisions with tactical academic professionalism.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-bus941-1", title: "BUS 941 Doctoral Publication Handbook & Style Guide", type: "Syllabus", size: "3.2 MB", date: "12 Oct 2026", file: "BUS941_Publication_Guide.pdf", status: "Published" },
      { id: "mat-bus941-2", title: "Executive Template: Journal Manuscript Submission Framework", type: "Document", size: "1.1 MB", date: "15 Oct 2026", file: "Doctoral_Manuscript_Template_AKSU.docx", status: "Published" }
    ],
    assignments: [
      { id: "asg-bus941-1", title: "Targeted Journal Manuscript Draft (Introduction & Theory)", brief: "Prepare a 15-page manuscript draft targeted at an ABS-indexed journal, containing a rigorous introduction, problem statement, and conceptual framework.", dueDate: "18th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 6, status: "Active" }
    ],
    enrolledStudents: DBA_CANDIDATES,
    announcements: [
      { id: "anc-ukp-1", date: "19 Oct 2026", title: "Individual Writing Clinics Available", body: "Book your 20-minute thesis outline review session via the faculty messaging desk." }
    ]
  },

  // ---------------------------------------------------------------------------------------
  // 2. MASTER OF ACCOUNTING AND FINANCE (MAF) COURSES
  // ---------------------------------------------------------------------------------------
  {
    code: "MAF 801",
    title: "Bus. Stats & Data Analytics",
    shortTitle: "Bus. Stats & Analytics",
    programmeId: "maf",
    programmeName: "Master of Accounting and Finance (MAF)",
    degreeLevel: "Master's",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Accounting",
    schedule: "Saturdays 08:30 - 11:30",
    venue: "Amphitheatre C & Virtual Studio",
    lecturerId: "fac-uford",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-uford"),
    overview: "Statistical techniques for financial decision-making. Probability distributions, hypothesis testing, ANOVA, linear and multiple regression, time-series forecasting, and Python/Excel analytics for financial risk evaluation.",
    learningOutcomes: [
      "Apply probability concepts to portfolio risk modeling and Value-at-Risk (VaR) estimations.",
      "Execute multiple regression in Excel and Python to evaluate capital structure determinants.",
      "Interpret p-values, t-statistics, and F-distributions in financial accounting research.",
      "Construct interactive financial dashboards for executive performance tracking."
    ],
    modules: [
      { number: "Module 1", title: "Descriptive Financial Statistics & Probability Distributions", duration: "50 mins", videoTimestamp: 0, keyTakeaway: "Normal, log-normal distributions and standard deviation in stock market volatility.", status: "Active / Published" },
      { number: "Module 2", title: "Hypothesis Testing & Statistical Inference for Financial Decisions", duration: "55 mins", videoTimestamp: 20, keyTakeaway: "One-sample and two-sample t-tests in evaluating abnormal investment returns.", status: "Active / Published" },
      { number: "Module 3", title: "Multiple Regression Analytics & Ordinary Least Squares", duration: "60 mins", videoTimestamp: 45, keyTakeaway: "Estimating beta and financial asset sensitivity parameters.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-maf801-1", title: "MAF 801 Financial Statistics Study Pack & Formula Reference", type: "Syllabus", size: "3.9 MB", date: "11 Oct 2026", file: "MAF801_Stats_Syllabus.pdf", status: "Published" },
      { id: "mat-maf801-2", title: "Practical Financial Analytics Model in Excel", type: "Dataset", size: "4.8 MB", date: "15 Oct 2026", file: "Financial_Statistics_Toolkit_v2.xlsx", status: "Published" }
    ],
    assignments: [
      { id: "asg-maf801-1", title: "Financial Regression Analysis Project", brief: "Analyze the relationship between dividend payout ratio, leverage, and firm valuation for 20 quoted Nigerian manufacturing companies.", dueDate: "2nd November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 8, status: "Active" }
    ],
    enrolledStudents: MAF_CANDIDATES,
    announcements: [
      { id: "anc-maf1", date: "17 Oct 2026", title: "Excel Financial Solver Add-in Instructions", body: "Please activate the Analysis ToolPak and Solver Add-in in your MS Excel before class." }
    ]
  },
  {
    code: "ACC 801",
    title: "Fin.Reporting under IFRS",
    shortTitle: "Financial Reporting under IFRS",
    programmeId: "maf",
    programmeName: "Master of Accounting and Finance (MAF)",
    degreeLevel: "Master's",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Accounting",
    schedule: "Saturdays 12:00 - 15:00",
    venue: "Amphitheatre A & Virtual Studio",
    lecturerId: "fac-mbobo",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-mbobo"),
    overview: "Comprehensive study of International Financial Reporting Standards (IFRS/IAS). Focuses on revenue recognition (IFRS 15), financial instruments (IFRS 9), leases (IFRS 16), fair value measurement (IFRS 13), and group consolidated financial statement preparation.",
    learningOutcomes: [
      "Prepare group consolidated financial statements complying with IFRS 10, 11, and 12.",
      "Account for complex financial instruments, hedging, and expected credit loss under IFRS 9.",
      "Analyze lease liability capitalization and right-of-use asset amortisation under IFRS 16.",
      "Audit financial statement disclosures for compliance with ICAN and Financial Reporting Council of Nigeria standards."
    ],
    modules: [
      { number: "Module 1", title: "The Conceptual Framework for Financial Reporting & Fair Value Measurement", duration: "55 mins", videoTimestamp: 0, keyTakeaway: "Hierarchy of fair value inputs (Level 1, 2, 3) and faithful representation.", status: "Active / Published" },
      { number: "Module 2", title: "IFRS 15: Revenue from Contracts with Customers (The 5-Step Model)", duration: "60 mins", videoTimestamp: 20, keyTakeaway: "Identifying performance obligations and transaction price allocations.", status: "Active / Published" },
      { number: "Module 3", title: "IFRS 9: Financial Assets, Liabilities, and Expected Credit Loss Provisioning", duration: "65 mins", videoTimestamp: 45, keyTakeaway: "Amortised cost, FVOCI, FVPL, and 3-stage impairment staging.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-acc801-1", title: "ACC 801 IFRS Reporting Comprehensive Study Text", type: "Syllabus", size: "6.2 MB", date: "10 Oct 2026", file: "ACC801_IFRS_Study_Pack.pdf", status: "Published" },
      { id: "mat-acc801-2", title: "Consolidated Financial Statement Workshop Workbook", type: "Dataset", size: "3.5 MB", date: "14 Oct 2026", file: "IFRS_Consolidation_Model_Practice.xlsx", status: "Published" }
    ],
    assignments: [
      { id: "asg-acc801-1", title: "IFRS 16 Lease Impact Diagnostic Case", brief: "Quantify the balance sheet and EBITDA impact of transitioning operating leases to Right-of-Use assets for an aviation or logistics company.", dueDate: "8th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 8, status: "Active" }
    ],
    enrolledStudents: MAF_CANDIDATES,
    announcements: [
      { id: "anc-mb-1", date: "16 Oct 2026", title: "FRCN Regulatory Updates Circulated", body: "Recent Financial Reporting Council circular on climate disclosures has been uploaded to the materials repository." }
    ]
  },
  {
    code: "FIN 811",
    title: "Corp. Finance & Valuation",
    shortTitle: "Corporate Finance & Valuation",
    programmeId: "maf",
    programmeName: "Master of Accounting and Finance (MAF)",
    degreeLevel: "Master's",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Banking & Finance",
    schedule: "Saturdays 15:30 - 18:30",
    venue: "Amphitheatre A & Virtual Studio",
    lecturerId: "fac-ubom",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-ubom"),
    overview: "Advanced corporate capital management, investment decision rules, cost of capital (WACC), capital structure theories (Modigliani-Miller, Trade-off, Pecking Order), discounted cash flow (DCF) valuation, and corporate restructuring.",
    learningOutcomes: [
      "Construct multi-stage Discounted Cash Flow (DCF) models with terminal value sensitivity.",
      "Calculate Weighted Average Cost of Capital (WACC) adjusting for emerging market country risk premiums.",
      "Evaluate cross-border mergers, acquisitions, and synergistic enterprise values.",
      "Determine optimum dividend payout and debt-equity financing strategies."
    ],
    modules: [
      { number: "Module 1", title: "Capital Budgeting Under Uncertainty: NPV, IRR, and Real Options", duration: "55 mins", videoTimestamp: 0, keyTakeaway: "Discounted cash flow vs real options in oil and gas infrastructure investments.", status: "Active / Published" },
      { number: "Module 2", title: "Cost of Capital: CAPM, Beta Adjustments & Emerging Market Country Risk Premiums", duration: "60 mins", videoTimestamp: 20, keyTakeaway: "Estimating sovereign risk spreads and adjusted cost of equity.", status: "Active / Published" },
      { number: "Module 3", title: "Enterprise Valuation: Free Cash Flow to Firm (FCFF) vs Free Cash Flow to Equity (FCFE)", duration: "65 mins", videoTimestamp: 45, keyTakeaway: "Building defensible valuation multiples and terminal growth rates.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-fin811-1", title: "FIN 811 Corporate Valuation Handbook & Financial Model Templates", type: "Syllabus", size: "5.4 MB", date: "12 Oct 2026", file: "FIN811_Corporate_Finance_Valuation.pdf", status: "Published" },
      { id: "mat-fin811-2", title: "Financial Model: DCF Valuation Template for Listed Entities", type: "Dataset", size: "7.1 MB", date: "15 Oct 2026", file: "DCF_Valuation_Model_Template.xlsx", status: "Published" }
    ],
    assignments: [
      { id: "asg-fin811-1", title: "Comprehensive Corporate Valuation Paper", brief: "Perform a DCF and relative multiple valuation of a quoted company on the NGX. Present DCF base, bull, and bear scenarios with sensitivity matrices.", dueDate: "12th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 8, status: "Active" }
    ],
    enrolledStudents: MAF_CANDIDATES,
    announcements: [
      { id: "anc-ub-1", date: "17 Oct 2026", title: "Bloomberg Terminal Access Hours", body: "Scholars may access Bloomberg valuation terminals at the Main Campus E-Library between 08:00 and 18:00 daily." }
    ]
  },
  {
    code: "ACC 811",
    title: "Mgmt Accounting & Control",
    shortTitle: "Management Accounting & Control",
    programmeId: "maf",
    programmeName: "Master of Accounting and Finance (MAF)",
    degreeLevel: "Master's",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Accounting",
    schedule: "Fridays 16:00 - 19:00",
    venue: "Amphitheatre C & Virtual Studio",
    lecturerId: "fac-okpo",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-okpo"),
    overview: "Strategic cost management, Activity-Based Costing (ABC/ABM), Target Costing, Life-Cycle Costing, Balanced Scorecard design, divisional performance measurement, transfer pricing, and modern budgetary control systems.",
    learningOutcomes: [
      "Implement Activity-Based Costing (ABC) systems to identify product and customer profitability.",
      "Design Balanced Scorecard dashboards across financial, customer, internal, and innovation perspectives.",
      "Formulate optimal transfer pricing policies between decentralized corporate divisions.",
      "Analyze standard costing variances to guide strategic operational interventions."
    ],
    modules: [
      { number: "Module 1", title: "Strategic Cost Management & Activity-Based Costing (ABC)", duration: "50 mins", videoTimestamp: 0, keyTakeaway: "Cost pools, cost drivers, and overcoming distortions of traditional volume absorption.", status: "Active / Published" },
      { number: "Module 2", title: "The Balanced Scorecard & Strategic Performance Measurement", duration: "55 mins", videoTimestamp: 20, keyTakeaway: "Cascading strategy maps and Key Performance Indicators (KPIs) through organizational units.", status: "Active / Published" },
      { number: "Module 3", title: "Transfer Pricing in Decentralized Multidivisional Enterprises", duration: "50 mins", videoTimestamp: 45, keyTakeaway: "Market-based, cost-based, and negotiated transfer pricing under tax jurisdiction constraints.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-acc811-1", title: "ACC 811 Strategic Management Accounting Guide", type: "Syllabus", size: "4.1 MB", date: "10 Oct 2026", file: "ACC811_Management_Accounting.pdf", status: "Published" },
      { id: "mat-acc811-2", title: "Activity-Based Costing Corporate Simulation Model", type: "Dataset", size: "3.2 MB", date: "14 Oct 2026", file: "ABC_Simulation_Model.xlsx", status: "Published" }
    ],
    assignments: [
      { id: "asg-acc811-1", title: "Balanced Scorecard Strategic Implementation Plan", brief: "Design a comprehensive Balanced Scorecard framework for a manufacturing or public utility organization, incorporating at least 4 strategic objectives and metrics per perspective.", dueDate: "15th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 8, status: "Active" }
    ],
    enrolledStudents: MAF_CANDIDATES,
    announcements: [
      { id: "anc-ok-1", date: "18 Oct 2026", title: "Case Analysis Syndicate Groups Formed", body: "Check the course workspace for your assigned syndicate partners for Friday's case review." }
    ]
  },
  {
    code: "MAF 811",
    title: "Research Methodology",
    shortTitle: "Research Methodology",
    programmeId: "maf",
    programmeName: "Master of Accounting and Finance (MAF)",
    degreeLevel: "Master's",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Banking & Finance",
    schedule: "Thursdays 15:30 - 18:30",
    venue: "Amphitheatre B & Virtual Studio",
    lecturerId: "fac-eshiet",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-eshiet"),
    overview: "Research design, formulation of research dilemmas, literature review techniques, sampling procedures, questionnaire design, secondary financial data collection, and preparation of defensible master's theses.",
    learningOutcomes: [
      "Articulate precise, defensible research problem statements in accounting and finance.",
      "Conduct systematic literature reviews synthesizing theoretical and empirical findings.",
      "Design valid, reliable empirical survey questionnaires and pilot testing protocols.",
      "Prepare a comprehensive master's thesis research proposal for departmental approval."
    ],
    modules: [
      { number: "Module 1", title: "Formulating Defensible Research Problems & Hypotheses in Finance", duration: "50 mins", videoTimestamp: 0, keyTakeaway: "Identifying gaps in frontier literature versus replicating trivial studies.", status: "Active / Published" },
      { number: "Module 2", title: "Secondary Financial Data Mining from Audited Annual Reports & Datastream", duration: "55 mins", videoTimestamp: 20, keyTakeaway: "Extracting ratios, restatements, and adjusting for stock splits and mergers.", status: "Active / Published" },
      { number: "Module 3", title: "Master's Thesis Proposal Architecture & Defence Protocols", duration: "60 mins", videoTimestamp: 45, keyTakeaway: "Writing chapters 1 to 3 with rigorous referencing and internal consistency.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-maf811-1", title: "MAF 811 Research Methodology Manual & Proposal Template", type: "Syllabus", size: "3.5 MB", date: "11 Oct 2026", file: "MAF811_Research_Manual.pdf", status: "Published" },
      { id: "mat-maf811-2", title: "Senate Guidelines for Postgraduate Research Proposal Defence", type: "Document", size: "1.8 MB", date: "14 Oct 2026", file: "Postgraduate_Thesis_Regulations_2026.pdf", status: "Published" }
    ],
    assignments: [
      { id: "asg-maf811-1", title: "Master's Thesis Research Proposal (Chapters 1 - 3)", brief: "Submit a complete 25-page Master's thesis proposal containing Chapter 1 (Introduction), Chapter 2 (Literature Review), and Chapter 3 (Methodology).", dueDate: "25th November 2026", weight: "40% Continuous Assessment", points: 40, submissionsCount: 8, status: "Active" }
    ],
    enrolledStudents: MAF_CANDIDATES,
    announcements: [
      { id: "anc-esh-1", date: "19 Oct 2026", title: "Proposal Defence Colloquium Schedule", body: "Departmental thesis proposal defence colloquium is scheduled for early December. Proposals must be cleared by November 25." }
    ]
  },

  // ---------------------------------------------------------------------------------------
  // 3. DOCTOR OF ACCOUNTING AND FINANCE (DAF) COURSES
  // ---------------------------------------------------------------------------------------
  {
    code: "DAF 901",
    title: "Philosophy and Foundations of Business research",
    shortTitle: "Philosophy of Business Research",
    programmeId: "daf",
    programmeName: "Doctor of Accounting and Finance (DAF)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Business Administration",
    schedule: "Saturdays 09:00 - 12:00",
    venue: "Senate Doctoral Amphitheatre & Virtual Studio",
    lecturerId: "fac-ibok",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-ibok"),
    overview: "Philosophical underpinnings of social science and financial accounting research. Epistemological and ontological stances (positivism, interpretivism, critical realism, pragmatism), the sociology of scientific knowledge, paradigm shifts (Kuhn), and theoretical conceptualization.",
    learningOutcomes: [
      "Critically evaluate ontological and epistemological assumptions in financial scholarship.",
      "Defend paradigm choices (Positivism vs Constructivism) before doctoral examination panels.",
      "Formulate coherent theoretical and conceptual frameworks for doctoral dissertations.",
      "Analyze the axiological dimensions and ethical responsibilities of doctoral business inquiry."
    ],
    modules: [
      { number: "Module 1", title: "Ontological Paradigms: Realism, Nominalism & Social Reality in Finance", duration: "60 mins", videoTimestamp: 0, keyTakeaway: "Does financial value exist objectively or is it socially constructed through market perceptions?", status: "Active / Published" },
      { number: "Module 2", title: "Epistemology & Knowledge Validation: Positivism vs Interpretivism", duration: "65 mins", videoTimestamp: 20, keyTakeaway: "Hypothetico-deductive testing vs inductive narrative meaning in boardroom governance.", status: "Active / Published" },
      { number: "Module 3", title: "Saunders' Research Onion & Methodological Coherence in DAF Inquiries", duration: "55 mins", videoTimestamp: 45, keyTakeaway: "Aligning philosophy, approach, strategy, choices, time horizons, and empirical procedures.", status: "Upcoming" },
      { number: "Module 4", title: "Paradigm Shifts & Scientific Revolutions: Kuhn and Lakatos Applied to Accounting", duration: "50 mins", videoTimestamp: 70, keyTakeaway: "How positive accounting theory overturned normative accounting doctrine.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-daf901-1", title: "DAF 901 Philosophy of Business Research Master Reader (Vol 1)", type: "Syllabus", size: "4.8 MB", date: "10 Oct 2026", file: "DAF901_Philosophy_Reader.pdf", status: "Published" },
      { id: "mat-daf901-2", title: "Saunders Research Onion Master Framework & Analysis Matrix", type: "Document", size: "2.3 MB", date: "14 Oct 2026", file: "Saunders_Research_Onion_Matrix.pdf", status: "Published" },
      { id: "mat-daf901-3", title: "Doctoral Lecture Recording: Epistemological Foundations in Corporate Finance", type: "Video", size: "580 MB", date: "17 Oct 2026", file: "DAF901_Session1_Epistemology_HD.mp4", status: "Published" }
    ],
    assignments: [
      { id: "asg-daf901-1", title: "Philosophical Positioning Paper (Doctoral Matrix)", brief: "Submit an ontological, epistemological, and axiological positioning matrix for your proposed doctoral research dissertation, comparing how a Positivist versus a Critical Realist would investigate your topic.", dueDate: "31st October 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 5, status: "Active" }
    ],
    enrolledStudents: DAF_CANDIDATES,
    announcements: [
      { id: "anc-ib-1", date: "18 Oct 2026", title: "Doctoral Colloquium Schedule Announced", body: "The Saturday colloquium on Kuhn's paradigm shifts will begin promptly at 09:00 in the Senate Amphitheatre." }
    ]
  },
  {
    code: "DAF 911",
    crossListing: "BUS/DAF 911",
    title: "Advanced Quantitative Analysis and Econometrics",
    shortTitle: "Adv. Quant & Econometrics",
    programmeId: "daf",
    programmeName: "Doctor of Accounting and Finance (DAF)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2025/2026",
    academicSession: "2025/2026",
    department: "Department of Banking & Finance",
    schedule: "Saturdays 12:30 - 15:30",
    venue: "Doctoral Econometric Lab & Virtual Studio, Obio Akpa Campus / Uyo Liaison Office",
    lecturerId: "fac-daniel",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-daniel"),
    overview: "This course provides doctoral candidates in Accounting and Finance with advanced training in quantitative methods and econometric analysis for business research. It covers probability, sampling, and statistical inference; the classical linear regression model and its extensions; violations of classical assumptions including heteroskedasticity, autocorrelation, and endogeneity; instrumental variables estimation; diagnostic testing; and hands-on estimation using Stata, R, and Python with published management and firm-level datasets. The emphasis is on both theoretical understanding and practical application to doctoral-level research problems in business and management.",
    learningOutcomes: [
      "Master foundations of statistical inference, probability distributions, and hypothesis testing power.",
      "Formulate, estimate, and interpret the Classical Linear Regression Model (OLS) and its mathematical properties.",
      "Diagnose and remediate violations of classical assumptions: heteroskedasticity, autocorrelation, and endogeneity.",
      "Execute Instrumental Variables (2SLS) and dynamic panel data models to resolve omitted variable bias.",
      "Implement hands-on econometric workflows in Stata, R, and Python with published firm-level and management datasets.",
      "Critically evaluate and defend doctoral-level quantitative methodology for business research dissertations."
    ],
    modules: [
      {
        number: "Week 1",
        title: "Probability, Sampling, and Statistical Inference",
        majorTopic: "Foundations of statistical reasoning for business research",
        minorTopics: [
          "i. Probability distributions and random variables",
          "ii. Sampling methods and sampling distributions",
          "iii. Point estimation and confidence intervals",
          "iv. Hypothesis testing: Type I and Type II errors, power"
        ],
        readings: [
          "Stock & Watson (2021): chapters on probability and statistical inference",
          "Wooldridge (2025): chapters on the nature of econometrics and data",
          "Greene (2018): review of probability and distribution theory"
        ],
        duration: "180 mins",
        videoTimestamp: 0,
        keyTakeaway: "Foundations of statistical inference, probability distributions, confidence intervals, and hypothesis test power.",
        status: "Active / Published"
      },
      {
        number: "Week 2",
        title: "The Classical Linear Regression Model",
        majorTopic: "Simple and multiple linear regression; OLS estimation",
        minorTopics: [
          "i. The linear regression model and its assumptions",
          "ii. Ordinary Least Squares (OLS) estimation",
          "iii. Properties of OLS estimators: unbiasedness, efficiency, consistency",
          "iv. Goodness of fit and coefficient of determination"
        ],
        readings: [
          "Stock & Watson (2021): chapters on linear regression with one and multiple regressors",
          "Wooldridge (2025): chapters on simple and multiple regression analysis",
          "Greene (2018): the linear regression model and least squares estimation"
        ],
        duration: "180 mins",
        videoTimestamp: 20,
        keyTakeaway: "Gauss-Markov theorem, OLS unbiasedness, efficiency, consistency, and R-squared interpretation.",
        status: "Active / Published"
      },
      {
        number: "Week 3",
        title: "Inference in the Linear Regression Model",
        majorTopic: "Hypothesis testing and confidence intervals in regression",
        minorTopics: [
          "i. Sampling distributions of OLS estimators",
          "ii. t-tests and F-tests for linear restrictions",
          "iii. Confidence intervals and prediction intervals",
          "iv. Model specification and functional form"
        ],
        readings: [
          "Stock & Watson (2021): chapters on regression inference and hypothesis testing",
          "Wooldridge (2025): chapters on inference in multiple regression",
          "Greene (2018): hypothesis testing and model selection"
        ],
        duration: "180 mins",
        videoTimestamp: 40,
        keyTakeaway: "Joint hypothesis testing via F-tests, confidence bands, functional form transformations, and polynomial regressors.",
        status: "Active / Published"
      },
      {
        number: "Week 4",
        title: "Heteroskedasticity and Autocorrelation",
        majorTopic: "Violations of classical assumptions and robust inference",
        minorTopics: [
          "i. Detection of heteroskedasticity (Breusch-Pagan, White tests)",
          "ii. Consequences for OLS and remedial measures",
          "iii. Autocorrelation in time series: detection and correction",
          "iv. Heteroskedasticity-robust and autocorrelation-robust standard errors"
        ],
        readings: [
          "Wooldridge (2025): chapters on heteroskedasticity and serial correlation",
          "Greene (2018): the generalized regression model and heteroskedasticity",
          "Stock & Watson (2021): chapters on regression with time series data and robust standard errors"
        ],
        duration: "180 mins",
        videoTimestamp: 60,
        keyTakeaway: "White-Huber robust SEs, Breusch-Pagan test, Durbin-Watson, Newey-West HAC standard errors.",
        status: "Active / Published"
      },
      {
        number: "Week 5",
        title: "Endogeneity and Instrumental Variables",
        majorTopic: "Endogeneity problems and IV estimation",
        minorTopics: [
          "i. Sources of endogeneity: omitted variables, measurement error, simultaneity",
          "ii. Instrumental variables: validity and relevance conditions",
          "iii. Two-Stage Least Squares (2SLS) estimation",
          "iv. Testing for endogeneity and overidentification"
        ],
        readings: [
          "Wooldridge (2025): chapters on instrumental variables estimation",
          "Greene (2018): instrumental variables and simultaneous equations",
          "Angrist & Pischke (2009): chapters on instrumental variables and natural experiments"
        ],
        duration: "180 mins",
        videoTimestamp: 80,
        keyTakeaway: "Identification strategy, 2SLS estimation, Hausman endogeneity test, Sargan-Hansen J overidentification test.",
        status: "Upcoming"
      },
      {
        number: "Week 6",
        title: "Panel Data Models",
        majorTopic: "Fixed effects, random effects, and panel data estimation",
        minorTopics: [
          "i. Benefits of panel data for controlling unobserved heterogeneity",
          "ii. Pooled OLS, fixed effects, and first-differencing estimators",
          "iii. Random effects estimation and the Hausman test",
          "iv. Clustered standard errors in panel settings"
        ],
        readings: [
          "Wooldridge (2025): chapters on panel data models",
          "Greene (2018): models for panel data",
          "Angrist & Pischke (2009): chapters on panel data and difference-in-differences"
        ],
        duration: "180 mins",
        videoTimestamp: 100,
        keyTakeaway: "Within-group vs between-group transformation, Hausman test, and firm-clustered standard errors.",
        status: "Upcoming"
      },
      {
        number: "Week 7",
        title: "Binary Choice and Limited Dependent Variable Models",
        majorTopic: "Qualitative response models for limited dependent variables",
        minorTopics: [
          "i. Linear Probability Model: estimation and drawbacks",
          "ii. Logit and Probit models: specification and interpretation",
          "iii. Maximum Likelihood Estimation for binary outcomes",
          "iv. Marginal effects and goodness-of-fit measures"
        ],
        readings: [
          "Wooldridge (2025): chapters on discrete response models",
          "Greene (2018): discrete choice models",
          "Stock & Watson (2021): chapters on binary dependent variables"
        ],
        duration: "180 mins",
        videoTimestamp: 120,
        keyTakeaway: "Odds ratios, Probit vs Logit, Maximum Likelihood estimation, and average marginal effects (AME).",
        status: "Upcoming"
      },
      {
        number: "Week 8",
        title: "Diagnostic Testing and Model Specification",
        majorTopic: "Specification tests and model validation",
        minorTopics: [
          "i. Tests for omitted variables and functional form misspecification",
          "ii. Ramsey RESET test and related diagnostics",
          "iii. Tests for structural breaks",
          "iv. Outlier detection and influence diagnostics"
        ],
        readings: [
          "Greene (2018): hypothesis testing and model selection",
          "Wooldridge (2019): chapters on specification testing",
          "Stock & Watson (2015): chapters on assessing studies and regression diagnostics"
        ],
        duration: "180 mins",
        videoTimestamp: 140,
        keyTakeaway: "Ramsey RESET test, Chow structural break test, Cook's distance, and leverage influence analysis.",
        status: "Upcoming"
      },
      {
        number: "Week 9",
        title: "Time Series: Stationarity, ARIMA, and Forecasting",
        majorTopic: "Time series econometrics for business forecasting",
        minorTopics: [
          "i. Stationarity and unit root tests (ADF, PP)",
          "ii. ARIMA models: identification, estimation, and diagnostic checking",
          "iii. Forecasting and forecast evaluation",
          "iv. Vector Autoregressions (VAR) for multivariate time series"
        ],
        readings: [
          "Stock & Watson (2021): chapters on time series regression and forecasting",
          "Greene (2018): time series models and nonstationary data",
          "Wooldridge (2025): chapters on time series regression"
        ],
        duration: "180 mins",
        videoTimestamp: 160,
        keyTakeaway: "Augmented Dickey-Fuller (ADF) & Phillips-Perron tests, Box-Jenkins ARIMA methodology, and VAR impulse response functions.",
        status: "Upcoming"
      },
      {
        number: "Week 10",
        title: "Hands-On Estimation in Stata",
        majorTopic: "Practical implementation of econometric methods in Stata",
        minorTopics: [
          "i. Data management and exploratory analysis in Stata",
          "ii. Regression commands and robust standard errors",
          "iii. Panel data estimation and post-estimation commands",
          "iv. Reproducible research workflows"
        ],
        readings: [
          "Adkins & Hill (2011): Using Stata for Principles of Econometrics (4th ed.)",
          "Wooldridge (2025): empirical exercises and computer exercises",
          "Selected Stata documentation and tutorials (to be sourced)"
        ],
        duration: "180 mins",
        videoTimestamp: 180,
        keyTakeaway: "Mastering Stata commands: regress, ivregress 2sls, xtreg, fe, re, estat hettest, and publication-ready outreg2 tables.",
        status: "Upcoming"
      },
      {
        number: "Week 11",
        title: "Hands-On Estimation in R and Python",
        majorTopic: "Practical implementation of econometric methods in R and Python",
        minorTopics: [
          "i. Data manipulation and visualization in R/Python",
          "ii. Regression, panel data, and binary choice estimation",
          "iii. Packages and libraries for econometrics",
          "iv. Comparison of Stata, R, and Python workflows"
        ],
        readings: [
          "Angrist & Pischke (2009): empirical examples and replication logic",
          "Selected R and Python econometrics tutorials (provided in class)",
          "Wooldridge (2025): computer exercises adaptable to R/Python"
        ],
        duration: "180 mins",
        videoTimestamp: 200,
        keyTakeaway: "Python statsmodels/linearmodels and R plm/fixest pipelines, tidyverse data wrangling, and ggplot2 diagnostics.",
        status: "Upcoming"
      },
      {
        number: "Week 12",
        title: "Applications to Firm-Level and Management Data",
        majorTopic: "Empirical applications using published business datasets",
        minorTopics: [
          "i. Working with firm-level datasets (Compustat-style, survey data)",
          "ii. Endogeneity and identification in management research",
          "iii. Panel data applications in strategy and finance",
          "iv. Replication and robustness in empirical business research"
        ],
        readings: [
          "Angrist & Pischke (2009): applications and empirical strategies",
          "Selected published papers using firm-level data (to be sourced)",
          "Wooldridge (2025): empirical examples and case studies"
        ],
        duration: "180 mins",
        videoTimestamp: 220,
        keyTakeaway: "Managing micro datasets, addressing survival bias, winsorization, cluster correction, and robustness test matrices.",
        status: "Upcoming"
      },
      {
        number: "Week 13",
        title: "Course Review and Research Project Presentations",
        majorTopic: "Synthesis and assessment",
        minorTopics: [
          "i. Integration of econometric methods for DBA research",
          "ii. Research project presentations",
          "iii. Course review and examination preparation"
        ],
        readings: [
          "Review all assigned readings across Weeks 1 to 12"
        ],
        duration: "180 mins",
        videoTimestamp: 240,
        keyTakeaway: "Defending econometric methodology before doctoral review panel, addressing identification challenges, and Viva Voce preparation.",
        status: "Upcoming"
      }
    ],
    generalReferences: [
      {
        id: 1,
        author: "Stock, J. H., & Watson, M. W.",
        year: "2021",
        title: "Introduction to Econometrics",
        edition: "4th ed., Global Edition",
        publisher: "Pearson",
        isbn: "9781292264455",
        citation: "Stock, J. H., & Watson, M. W. (2021). Introduction to Econometrics (4th ed.). Pearson. ISBN: 9781292264455.",
        url: "https://www.pearson.com/en-gb/subject-catalog/p/introduction-to-econometrics-global-edition/P200000005728/9781292264455",
        altUrl: "https://www.worldcat.org/isbn/9781292264455",
        companionUrl: "https://www.princeton.edu/~mwatson/Stock-Watson-4_Global/",
        scope: "Foundational theory of probability, statistical inference, single & multiple regression, instrumental variables, and time series."
      },
      {
        id: 2,
        author: "Wooldridge, J. M.",
        year: "2025",
        title: "Introductory Econometrics: A Modern Approach",
        edition: "8th ed.",
        publisher: "Cengage Learning",
        isbn: "9798214050317",
        citation: "Wooldridge, J. M. (2025). Introductory Econometrics: A Modern Approach (8th ed.). Cengage. ISBN: 9798214050317.",
        url: "https://www.cengage.uk/9798214050317/",
        altUrl: "https://www.worldcat.org/isbn/9798214050317",
        scope: "Modern cross-sectional, time series, and panel data econometrics with extensive applied empirical computer exercises."
      },
      {
        id: 3,
        author: "Greene, W. H.",
        year: "2018",
        title: "Econometric Analysis",
        edition: "8th ed.",
        publisher: "Pearson",
        isbn: "9780134461366",
        citation: "Greene, W. H. (2018). Econometric Analysis (8th ed.). Pearson. ISBN: 9780134461366.",
        url: "https://www.pearson.com/en-us/subject-catalog/p/econometric-analysis/P200000005726/9780134461366",
        altUrl: "http://people.stern.nyu.edu/wgreene/Text/econometricanalysis.htm",
        scope: "Comprehensive doctoral-level treatise on linear and nonlinear econometric theory, generalized regression, GMM, and maximum likelihood."
      },
      {
        id: 4,
        author: "Angrist, J. D., & Pischke, J.-S.",
        year: "2009",
        title: "Mostly Harmless Econometrics: An Empiricist's Companion",
        edition: "1st ed.",
        publisher: "Princeton University Press",
        isbn: "9780691120355",
        citation: "Angrist, J. D., & Pischke, J.-S. (2009). Mostly Harmless Econometrics. Princeton University Press. ISBN: 9780691120355.",
        url: "https://press.princeton.edu/books/paperback/9780691120355/mostly-harmless-econometrics",
        altUrl: "https://www.mostlyharmlesseconometrics.com/",
        scope: "Applied identification strategies, natural experiments, instrumental variables, differences-in-differences, and regression discontinuity."
      },
      {
        id: 5,
        author: "Adkins, L. C., & Hill, R. C.",
        year: "2011",
        title: "Using Stata for Principles of Econometrics",
        edition: "4th ed.",
        publisher: "John Wiley & Sons",
        isbn: "9781118032084",
        citation: "Adkins, L. C., & Hill, R. C. (2011). Using Stata for Principles of Econometrics (4th ed.). Wiley. ISBN: 9781118032084.",
        url: "https://www.wiley.com/en-us/Using+Stata+for+Principles+of+Econometrics%2C+4th+Edition-p-9781118032084",
        altUrl: "http://www.principlesofeconometrics.com/stata.htm",
        scope: "Hands-on implementation of econometric techniques, commands, and do-files in Stata software."
      }
    ],
    softwareTools: [
      { name: "Stata 18", category: "Econometric Package", url: "https://www.stata.com/", desc: "Primary econometric estimation suite for OLS, 2SLS, panel data, and GMM." },
      { name: "R Project & CRAN", category: "Open Source Computing", url: "https://www.r-project.org/", desc: "Reproducible research, plm, fixest, and publication graphics." },
      { name: "Python Statsmodels", category: "Data Science & Econometrics", url: "https://www.statsmodels.org/", desc: "Statistical modeling, hypothesis testing, and regression diagnostics in Python." },
      { name: "Python Linearmodels", category: "Panel Econometrics", url: "https://bashtage.github.io/linearmodels/", desc: "Panel and instrumental variable regression models." }
    ],
    materials: [
      { id: "mat-bus911-outline", title: "BUS/DAF 911 Official Course Outline & Syllabus Dossier (2025/2026)", type: "Official Syllabus", size: "1.8 MB", date: "29 Oct 2026", file: "BUS_DAF_911_Official_Course_Outline_2025_2026.pdf", status: "Ratified & Live" },
      { id: "mat-bus911-ebook", title: "BUS/DAF 911 Executive Course Handbook & Study Reader (Interactive eBook)", type: "eBook Handbook", size: "6.2 MB", date: "30 Oct 2026", file: "BUS_DAF_911_Course_Handbook_eBook.html", status: "Published" },
      { id: "mat-bus911-stata", title: "Hands-On Econometrics in Stata 18 Guide & Do-Files Packet", type: "Software Lab", size: "8.4 MB", date: "28 Oct 2026", file: "Stata_18_Econometric_Estimation_Do_Files.zip", status: "Published" },
      { id: "mat-bus911-python", title: "Python & R Econometric Scripts for Dynamic Panel & IV Estimation", type: "Code Repository", size: "4.7 MB", date: "25 Oct 2026", file: "Python_R_Econometric_Notebooks.zip", status: "Published" },
      { id: "mat-bus911-data", title: "Empirical Firm-Level Dataset: Compustat & NGX Quoted Firms (2015-2025)", type: "Dataset", size: "26.3 MB", date: "20 Oct 2026", file: "Compustat_NGX_Firm_Level_Dataset.dta", status: "Published" },
      { id: "mat-bus911-refs", title: "Verified General Reference Bibliography & ISBN Reading List", type: "Bibliography", size: "1.2 MB", date: "29 Oct 2026", file: "Verified_References_Bibliography_ISBNs.pdf", status: "Published" }
    ],
    assignments: [
      { id: "asg-bus911-1", title: "CA1: Empirical Econometric Diagnostic Paper (Stata/R/Python)", brief: "Estimate a multivariate firm-level performance model using OLS and test for violations of classical assumptions (Heteroskedasticity, Autocorrelation, Multicollinearity). Present results in APA 7th edition regression tables.", dueDate: "15th November 2026", weight: "20% Continuous Assessment", points: 20, submissionsCount: 6, status: "Active" },
      { id: "asg-bus911-2", title: "CA2: Instrumental Variables (2SLS) & Dynamic Panel Model on Firm-Level Data", brief: "Formulate an identification strategy for an endogenous strategic variable (e.g., CEO duality, R&D intensity). Estimate via 2SLS and Fixed Effects panel data regressions. Report Hausman test and Hansen J overidentification tests.", dueDate: "29th November 2026", weight: "20% Continuous Assessment", points: 20, submissionsCount: 6, status: "Active" },
      { id: "asg-bus911-final", title: "Capstone: Doctoral Research Project Presentation & Viva Voce", brief: "Deliver a 15-minute empirical presentation integrating econometric methodology into your doctoral dissertation proposal, followed by faculty viva voce defense.", dueDate: "12th December 2026", weight: "50% Final Examination & Defense", points: 50, submissionsCount: 6, status: "Scheduled" }
    ],
    enrolledStudents: DAF_CANDIDATES,
    announcements: [
      { id: "anc-dan-daf-1", date: "29 Oct 2026", title: "Official 2025/2026 Course Outline & Syllabus Published", body: "Dr. Ekere Jacob Daniel has published the official 13-week course syllabus for BUS/DAF 911. Please review the 5 verified reference texts and download the Stata/Python lab packets." }
    ]
  },
  {
    code: "ACC 911",
    title: "Fin.Accounting Theory & research",
    shortTitle: "Fin. Accounting Theory & Research",
    programmeId: "daf",
    programmeName: "Doctor of Accounting and Finance (DAF)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Accounting",
    schedule: "Fridays 14:00 - 17:00",
    venue: "Forensic Accounting Lab & Virtual Studio",
    lecturerId: "fac-udoayang",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-udoayang"),
    overview: "Frontier doctoral scholarship in financial accounting theory. Positive Accounting Theory (Watts & Zimmerman), earnings management models (Jones, Modified Jones, Kothari), value relevance of accounting information (Ohlson model), and capital market research in accounting.",
    learningOutcomes: [
      "Critique Positive Accounting Theory hypotheses (bonus plan, debt covenant, political cost).",
      "Model discretionary accruals using the Modified Jones and Performance-Adjusted models.",
      "Execute the Ohlson Valuation Model to evaluate the value relevance of book value vs earnings.",
      "Evaluate corporate governance mechanisms curbing opportunistic financial reporting."
    ],
    modules: [
      { number: "Module 1", title: "Positive Accounting Theory vs Normative Doctrines", duration: "55 mins", videoTimestamp: 0, keyTakeaway: "Agency dilemmas, management incentives, and opportunistic accounting method choices.", status: "Active / Published" },
      { number: "Module 2", title: "Earnings Quality, Discretionary Accruals & Forensic Detection", duration: "65 mins", videoTimestamp: 20, keyTakeaway: "Decomposing total accruals into non-discretionary and discretionary components.", status: "Active / Published" },
      { number: "Module 3", title: "Value Relevance of Accounting Numbers (The Ohlson Model)", duration: "60 mins", videoTimestamp: 45, keyTakeaway: "Testing market efficiency and whether IFRS adoption enhanced financial value relevance.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-acc911-1", title: "ACC 911 Financial Accounting Theory Doctoral Reader", type: "Syllabus", size: "6.5 MB", date: "11 Oct 2026", file: "ACC911_Accounting_Theory_Reader.pdf", status: "Published" },
      { id: "mat-acc911-2", title: "Discretionary Accruals Stata Code & Empirical Model Package", type: "Dataset", size: "8.9 MB", date: "15 Oct 2026", file: "Modified_Jones_Model_Stata_Package.zip", status: "Published" }
    ],
    assignments: [
      { id: "asg-acc911-1", title: "Empirical Discretionary Accruals Estimation Paper", brief: "Estimate discretionary accruals using the Modified Jones model for all quoted non-financial firms on the NGX between 2018 and 2025.", dueDate: "15th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 5, status: "Active" }
    ],
    enrolledStudents: DAF_CANDIDATES,
    announcements: [
      { id: "anc-ud-1", date: "17 Oct 2026", title: "Doctoral Accounting Seminar Paper Guidelines", body: "Please ensure your seminar term paper complies with the British Accounting Review publication guidelines." }
    ]
  },
  {
    code: "FIN 911",
    title: "Theory of Finance & Asset pricing",
    shortTitle: "Theory of Finance & Asset Pricing",
    programmeId: "daf",
    programmeName: "Doctor of Accounting and Finance (DAF)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Banking & Finance",
    schedule: "Saturdays 15:30 - 18:30",
    venue: "Capital Markets Research Suite & Virtual Studio",
    lecturerId: "fac-ubom",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-ubom"),
    overview: "Doctoral-level asset pricing theory. Modern Portfolio Theory, Capital Asset Pricing Model (CAPM), Arbitrage Pricing Theory (APT), consumption-based CAPM, Fama-French multi-factor asset pricing models (3-factor and 5-factor), market efficiency anomalies, and behavioral finance.",
    learningOutcomes: [
      "Derive the theoretical foundations of the Mean-Variance Efficient Frontier and CAPM.",
      "Test empirical multi-factor asset pricing models (Fama-French, Carhart) using Fama-MacBeth regressions.",
      "Critically evaluate anomalies (size, value, momentum, profitability, investment) in frontier markets.",
      "Formulate novel behavioral asset pricing propositions explaining market mispricing."
    ],
    modules: [
      { number: "Module 1", title: "Foundations of Asset Pricing: Modern Portfolio Theory & The CAPM Derivation", duration: "60 mins", videoTimestamp: 0, keyTakeaway: "Systematic vs unsystematic risk and the pricing of covariance risk.", status: "Active / Published" },
      { number: "Module 2", title: "Arbitrage Pricing Theory (APT) & Multi-Factor Risk Models", duration: "65 mins", videoTimestamp: 20, keyTakeaway: "Macroeconomic risk factor loadings and no-arbitrage bounds.", status: "Active / Published" },
      { number: "Module 3", title: "The Fama-French 3-Factor and 5-Factor Asset Pricing Models", duration: "70 mins", videoTimestamp: 45, keyTakeaway: "SMB, HML, RMW, and CMA factors in explaining cross-sectional stock returns.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-fin911-1", title: "FIN 911 Asset Pricing Theory & Empirical Testing Reader", type: "Syllabus", size: "7.2 MB", date: "10 Oct 2026", file: "FIN911_Asset_Pricing_Reader.pdf", status: "Published" },
      { id: "mat-fin911-2", title: "Fama-French 5-Factor Data Packet for the Nigerian Stock Market", type: "Dataset", size: "12.4 MB", date: "16 Oct 2026", file: "Fama_French_NGX_Factors_2026.xlsx", status: "Published" }
    ],
    assignments: [
      { id: "asg-fin911-1", title: "Fama-MacBeth Two-Pass Regression Empirical Study", brief: "Construct 25 size and book-to-market portfolios for quoted Nigerian equities and test whether the Fama-French 5-Factor model prices cross-sectional returns.", dueDate: "19th November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 5, status: "Active" }
    ],
    enrolledStudents: DAF_CANDIDATES,
    announcements: [
      { id: "anc-ub-daf", date: "18 Oct 2026", title: "Journal of Finance Landmark Reprints Uploaded", body: "Key classic papers by Fama, French, and Cochrane have been uploaded to the readings section." }
    ]
  },
  {
    code: "DAF 941",
    title: "Business writing, publication & research ethics",
    shortTitle: "Writing, Publication & Ethics",
    programmeId: "daf",
    programmeName: "Doctor of Accounting and Finance (DAF)",
    degreeLevel: "Doctorate",
    credits: 3,
    semester: "First Semester 2026/2027",
    department: "Department of Accounting",
    schedule: "Thursdays 15:00 - 18:00",
    venue: "Doctoral Academic Writing Studio & Virtual Studio",
    lecturerId: "fac-ukpong",
    lecturer: FACULTY_LECTURERS.find(f => f.id === "fac-ukpong"),
    overview: "Doctoral writing excellence in accounting and finance scholarship. Publication in top-tier accounting journals, research ethics, human subject protection in corporate interviews, peer review management, and successful dissertation defence strategies.",
    learningOutcomes: [
      "Author doctoral accounting and financial empirical papers meeting ABS 3*/4* benchmarks.",
      "Navigate publication ethics, disclosure of conflicts of interest, and open science data sharing.",
      "Master the academic rhetoric of thesis defense and Viva Voce oral examinations.",
      "Develop executive policy briefs and regulatory whitepapers translating doctoral research for policymakers."
    ],
    modules: [
      { number: "Module 1", title: "Writing for Top-Tier Accounting & Finance Journals", duration: "55 mins", videoTimestamp: 0, keyTakeaway: "Structuring empirical contribution statements and framing methodological rigor.", status: "Active / Published" },
      { number: "Module 2", title: "Research Ethics, Institutional Review Boards (IRB) & Data Integrity", duration: "50 mins", videoTimestamp: 20, keyTakeaway: "Ethical guidelines in surveying corporate executives and access to confidential financial records.", status: "Active / Published" },
      { number: "Module 3", title: "Navigating the Viva Voce Examination: Defending Accounting Theses", duration: "60 mins", videoTimestamp: 45, keyTakeaway: "Anticipating external examiner critiques on ontology, endogeneity, and contribution.", status: "Upcoming" }
    ],
    materials: [
      { id: "mat-daf941-1", title: "DAF 941 Doctoral Writing & Publication Ethics Master Guide", type: "Syllabus", size: "3.6 MB", date: "12 Oct 2026", file: "DAF941_Writing_Ethics_Guide.pdf", status: "Published" },
      { id: "mat-daf941-2", title: "Senate Viva Voce Defence Handbook for Doctoral Candidates", type: "Document", size: "1.9 MB", date: "15 Oct 2026", file: "Senate_Viva_Voce_Guidelines.pdf", status: "Published" }
    ],
    assignments: [
      { id: "asg-daf941-1", title: "Targeted Journal Paper Manuscript (Full Draft)", brief: "Submit a complete 30-page empirical manuscript formatted according to the author guidelines of the Journal of Banking & Finance or Journal of Accounting Research.", dueDate: "22nd November 2026", weight: "30% Continuous Assessment", points: 30, submissionsCount: 5, status: "Active" }
    ],
    enrolledStudents: DAF_CANDIDATES,
    announcements: [
      { id: "anc-ukp-daf", date: "19 Oct 2026", title: "Doctoral Mock Viva Voce Registrations", body: "Mock defense presentation slots for November have been posted." }
    ]
  }
];

// Helper functions for retrieval
export const getCourseByCode = (code) => {
  return SEMESTER_COURSES.find(c => c.code.toLowerCase().replace(/\s+/g, '') === code.toLowerCase().replace(/\s+/g, '')) || SEMESTER_COURSES[0];
};

export const getCoursesByLecturerId = (lecturerId) => {
  return SEMESTER_COURSES.filter(c => c.lecturerId === lecturerId);
};

export const getCoursesByProgrammeId = (programmeId) => {
  return SEMESTER_COURSES.filter(c => c.programmeId.toLowerCase() === programmeId.toLowerCase());
};

export const getFacultyById = (id) => {
  return FACULTY_LECTURERS.find(f => f.id === id) || FACULTY_LECTURERS[0];
};
